"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParameterOrderField = exports.OrderDirection = exports.NodeOrderField = exports.MetricOrderField = exports.LinkedFlowOrderField = exports.LensOrderField = exports.LensFieldOrderField = exports.LabelOrderField = exports.InheritanceType = exports.HierarchyFieldOrderField = exports.GroupFieldOrderField = exports.GenericLabelOrderField = exports.FlowOutputStepOrderField = exports.FlowOutputFieldOrderField = exports.FlowOrderField = exports.FlowInputFieldOrderField = exports.FlowFieldOutputFieldOrderField = exports.FlowFieldInputFieldOrderField = exports.FlowColumnOutputFieldOrderField = exports.FlowColumnInputFieldOrderField = exports.FileOrderField = exports.FieldRoleCategory = exports.FieldRole = exports.FieldReferencingFieldOrderField = exports.FieldOrderField = exports.FieldDataType = exports.ExtractType = exports.EmbeddedDatasourceOrderField = exports.DatasourceOrderField = exports.DatasourceFilterOrderField = exports.DatasourceFieldOrderField = exports.DatabaseTableOrderField = exports.DatabaseServerOrderField = exports.DatabaseOrderField = exports.DataQualityWarningOrderField = exports.DataQualityCertificationOrderField = exports.DataFieldOrderField = exports.DashboardOrderField = exports.CustomSqlTableOrderField = exports.CombinedSetFieldOrderField = exports.CombinedFieldOrderField = exports.ColumnOrderField = exports.ColumnFieldOrderField = exports.CloudFileOrderField = exports.CertifiableOrderField = exports.CanHaveLabelsOrderField = exports.CalculatedFieldOrderField = exports.BinFieldOrderField = exports.AskDataExtensionOrderField = exports.AnalyticsFieldOrderField = void 0;
exports.FieldIconFragmentDoc = exports.NonDatasourceFieldIconFragmentDoc = exports.DatabasesByIdsNodesFragmentDoc = exports.DatabasesDisplayGridRowDataFragmentDoc = exports.DatabaseIconFragmentDoc = exports.TagsFragmentDoc = exports.DatabaseQueryFragmentDoc = exports.DatabaseFragmentDoc = exports.DatabaseCertificationFragmentDoc = exports.DatabaseLineageCountsFragmentDoc = exports.CertificationsFragmentDoc = exports.DataQualityCertificationAssetFragmentDoc = exports.DataQualityCertificationFragmentDoc = exports.DashboardsDisplayGridRowDataFragmentDoc = exports.CustomSqlFromDatasourceFragmentDoc = exports.CustomSqlDetailsFragmentDoc = exports.ConnectToTablesFragmentDoc = exports.ConnectToTablesConnectionFragmentDoc = exports.ConnectToDatabasesConnectionParamsFragmentDoc = exports.ConnectToDatabasesFragmentDoc = exports.DataQualityWarningAssetFragmentDoc = exports.DataQualityWarningFragmentDoc = exports.DatabaseServerOrPathFragmentDoc = exports.ColumnsReferencingFieldColumnsFragmentDoc = exports.ColumnFragmentDoc = exports.UpstreamColumnLabelsFragmentDoc = exports.LabelFragmentDoc = exports.LabelAssetFragmentDoc = exports.AssetFragmentDoc = exports.TableauUserFragmentDoc = exports.FlowColumnInputFieldRowDataFragmentDoc = exports.ColumnFieldsNodesFragmentDoc = exports.ColumnFieldsEmbeddedDatasourceFragmentDoc = exports.ColumnFieldsPublishedDatasourceFragmentDoc = exports.WorkbookOrderField = exports.WebDataConnectorOrderField = exports.WarnableOrderField = exports.VirtualConnectionTableOrderField = exports.VirtualConnectionOrderField = exports.ViewOrderField = exports.TaggableOrderField = exports.TagOrderField = exports.TableauUserOrderField = exports.TableauSiteOrderField = exports.TableOrderField = exports.SheetOrderField = exports.SetFieldOrderField = exports.RemoteType = exports.PublishedDatasourceOrderField = exports.PermissionMode = void 0;
exports.ViewDetailsByPathDashboardFragmentDoc = exports.SheetFieldInstanceFragmentDoc = exports.SheetFieldInstanceUpstreamDatabasesConnectionFragmentDoc = exports.SheetFieldInstanceDatasourceFieldFragmentDoc = exports.DatasourceFieldDetails_RemoteColumnFragmentDoc = exports.SheetFieldInstancePublishedDatasourceFragmentDoc = exports.SheetFieldInstanceDatasourceFragmentDoc = exports.TagsQueryWithFiltersTagsConnectionFragmentDoc = exports.TagsQueryWithFiltersTagsConnectionNodesFragmentDoc = exports.TableQueryFragmentDoc = exports.TableFragmentDoc = exports.TableCertificationFragmentDoc = exports.TableLineageCountsFragmentDoc = exports.TableColumnsByIdColumnsFragmentDoc = exports.ColumnsByTableIdFragmentDoc = exports.ColumnLabelsFragmentDoc = exports.SheetsDisplayGridRowDataFragmentDoc = exports.OwnersDisplayGridRowDataFragmentDoc = exports.OwnerIdFragmentDoc = exports.MetricsDisplayGridRowDataFragmentDoc = exports.LensesDisplayGridRowDataFragmentDoc = exports.LensUpstreamVirtualConnectionsNodesFragmentDoc = exports.VirtualConnectionsDisplayGridRowDataFragmentDoc = exports.LensLineageCountsFragmentDoc = exports.LensFieldsByIdFieldsConnectionNodesFragmentDoc = exports.InheritedLabelsFlowOutputFieldFragmentDoc = exports.InheritedLabelsFieldFragmentDoc = exports.InheritedLabelsColumnFragmentDoc = exports.FieldLabelsFragmentDoc = exports.FlowsDisplayGridRowDataFragmentDoc = exports.FlowDownstreamDatabasesFragmentDoc = exports.FlowDownstreamDatasourcesFragmentDoc = exports.FlowOutputStepsFragmentDoc = exports.FlowLineageCountsFragmentDoc = exports.FlowFieldsByIdNodesFragmentDoc = exports.FlowFieldsByIdFlowFieldOutputFieldFragmentDoc = exports.FlowFieldDetailsFlowFieldOutputFieldFragmentDoc = exports.FieldsReferencedByFieldNodesFragmentDoc = exports.FieldsReferencedByFieldNodesDatasourceFragmentDoc = exports.FieldLineageUpstreamDataQualityWarningsFragmentDoc = exports.FieldDetailsFragmentDoc = exports.FieldDetailsDatasourceFieldFragmentDoc = exports.NonDatasourceFieldDetailsFragmentDoc = exports.NonDatasourceFieldDetails_ColumnFragmentDoc = exports.NonDatasourceFieldDetails_UpstreamColumnFragmentDoc = exports.DatasourcesDisplayGridRowDataFragmentDoc = exports.DatasourceLineageCountsFragmentDoc = exports.DatasourceFieldsByIdNodesFragmentDoc = exports.FieldLineageUpstreamLabelsFragmentDoc = exports.FieldDescriptionInheritedFragmentDoc = void 0;
exports.DatabaseDownstreamSheetsDocument = exports.DatabaseDownstreamSheetsFilteredByTableDocument = exports.DatabaseDownstreamOwnersDocument = exports.DatabaseDownstreamOwnersFilteredByTableDocument = exports.DatabaseDownstreamOwnerIdsDocument = exports.DatabaseDownstreamOwnerIdsFilteredByTableDocument = exports.DatabaseDownstreamMetricsDocument = exports.DatabaseDownstreamMetricsFilteredByTableDocument = exports.DatabaseDownstreamLensesDocument = exports.DatabaseDownstreamLensesFilteredByTableDocument = exports.DatabaseDownstreamFlowsDocument = exports.DatabaseDownstreamFlowsFilteredByTableDocument = exports.DatabaseDownstreamDatasourcesDocument = exports.DatabaseDownstreamDatasourcesFilteredByTableDocument = exports.DatabaseDownstreamDatabasesDocument = exports.DatabaseDownstreamDatabasesFilteredByTableDocument = exports.DatabaseDownstreamDashboardsDocument = exports.DatabaseDownstreamDashboardsFilteredByTableDocument = exports.DataQualityWarningsInWebAuthoringDocument = exports.ViewWarningsDocument = exports.FlowCustomSqlDocument = exports.VirtualConnectionCustomSqlDocument = exports.PublishedDatasourceCustomSqlDocument = exports.WorkbookCustomSqlDocument = exports.ConnectToTablesTotalCountDocument = exports.ConnectToTablesDocument = exports.ConnectToTablesDescriptionDocument = exports.ConnectToTablesConnectionParamsDocument = exports.ConnectToDatabasesTotalCountDocument = exports.ConnectToDatabasesDocument = exports.ConnectToDatabasesDescriptionDocument = exports.ConnectToDatabasesConnectionParamsDocument = exports.ColumnsReferencingFieldDocument = exports.ColumnFlowsDocument = exports.ColumnFieldsDocument = exports.ColumnDetailsByLuidDocument = exports.ColumnDetailsDocument = exports.CatalogSelectorDropdownCountsDocument = exports.WorkbooksDisplayGridRowDataFragmentDoc = exports.WorkbookEmbeddedDatasourceFragmentDoc = exports.WorkbookLineageCountsFragmentDoc = exports.WorkbookFieldsByIdFieldsConnectionFragmentDoc = exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc = exports.TablesDisplayGridRowDataFragmentDoc = exports.TableDatabaseNameFragmentDoc = exports.VirtualConnectionTableLineageCountsFragmentDoc = exports.VirtualConnectionTablesFragmentDoc = exports.VirtualConnectionLineageCountsFragmentDoc = exports.ViewDetailsByPathFragmentDoc = exports.ViewDetailsByPathSheetFragmentDoc = void 0;
exports.DownstreamDashboardsFilteredByFieldDocument = exports.DatasourceUpstreamVirtualConnectionsDocument = exports.DatasourceUpstreamVirtualConnectionTablesDocument = exports.DatasourceUpstreamTablesDocument = exports.DatasourceUpstreamFlowsDocument = exports.DatasourceUpstreamDatasourcesDocument = exports.DatasourceUpstreamDatabasesDocument = exports.DatasourceDocument = exports.DatasourceLineageCountsDocument = exports.DatasourceLineageCountsFilteredByFieldDocument = exports.DatasourceFieldsWithInheritanceByIdDocument = exports.DatasourceFieldsByIdDocument = exports.DatasourceDownstreamWorkbooksDocument = exports.DatasourceDownstreamWorkbooksFilteredByFieldDocument = exports.DatasourceDownstreamTablesDocument = exports.DatasourceDownstreamSheetsDocument = exports.DatasourceDownstreamOwnersDocument = exports.DatasourceDownstreamOwnerIdsDocument = exports.DatasourceDownstreamMetricsDocument = exports.DatasourceDownstreamLensesDocument = exports.DatasourceDownstreamLensesFilteredByFieldDocument = exports.DatasourceDownstreamFlowsDocument = exports.DatasourceDownstreamDatasourcesDocument = exports.DatasourceDownstreamDatabasesDocument = exports.DatasourceDownstreamDashboardsDocument = exports.DatabasesDocument = exports.DatabasesByIdsDocument = exports.DatabasesByTagDocument = exports.DatabaseUpstreamTablesDocument = exports.DatabaseUpstreamTablesFilteredByTableDocument = exports.DatabaseUpstreamFlowsDocument = exports.DatabaseUpstreamFlowsFilteredByTableDocument = exports.DatabaseUpstreamDatasourcesDocument = exports.DatabaseUpstreamDatasourcesFilteredByTableDocument = exports.DatabaseUpstreamDatabasesDocument = exports.DatabaseUpstreamDatabasesFilteredByTableDocument = exports.DatabaseTablesByIdDocument = exports.DatabaseTableDocument = exports.DatabaseQueryWithCertificationsDocument = exports.DatabaseDocument = exports.DatabaseLineageCountsDocument = exports.DatabaseLineageCountsFilteredByTableDocument = exports.DatabaseDownstreamWorkbooksDocument = exports.DatabaseDownstreamWorkbooksFilteredByTableDocument = exports.DatabaseDownstreamVirtualConnectionsDocument = exports.DatabaseDownstreamVirtualConnectionsFilteredByTableDocument = exports.DatabaseDownstreamVirtualConnectionTablesDocument = exports.DatabaseDownstreamVirtualConnectionTablesFilteredByTableDocument = exports.DatabaseDownstreamTablesDocument = exports.DatabaseDownstreamTablesFilteredByTableDocument = void 0;
exports.FlowUpstreamVirtualConnectionsDocument = exports.FlowUpstreamVirtualConnectionsFilteredByFlowOutputFieldDocument = exports.FlowUpstreamVirtualConnectionTablesDocument = exports.FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldDocument = exports.FlowUpstreamTablesDocument = exports.FlowUpstreamTablesFilteredByFlowOutputFieldDocument = exports.FlowUpstreamFlowsDocument = exports.FlowUpstreamFlowsFilteredByFlowOutputFieldDocument = exports.FlowUpstreamDatasourcesDocument = exports.FlowUpstreamDatasourcesFilteredByFlowOutputFieldDocument = exports.FlowUpstreamDatabasesDocument = exports.FlowUpstreamDatabasesFilteredByFlowOutputFieldDocument = exports.FlowDocument = exports.FlowLineageCountsDocument = exports.FlowLineageCountsFilteredByFieldDocument = exports.FlowFieldsByIdDocument = exports.FlowFieldDetailsDocument = exports.FlowDownstreamWorkbooksDocument = exports.FlowDownstreamWorkbooksFilteredByFlowOutputFieldDocument = exports.FlowDownstreamTablesDocument = exports.FlowDownstreamTablesFilteredByFlowOutputFieldDocument = exports.FlowDownstreamSheetsDocument = exports.FlowDownstreamSheetsFilteredByFlowOutputFieldDocument = exports.FlowDownstreamOwnersDocument = exports.FlowDownstreamOwnersFilteredByFlowOutputFieldDocument = exports.FlowDownstreamOwnerIdsDocument = exports.FlowDownstreamOwnerIdsFilteredByFlowOutputFieldDocument = exports.FlowDownstreamMetricsDocument = exports.FlowDownstreamMetricsFilteredByFlowOutputFieldDocument = exports.FlowDownstreamLensesDocument = exports.FlowDownstreamLensesFilteredByFlowOutputFieldDocument = exports.FlowDownstreamFlowsDocument = exports.FlowDownstreamFlowsFilteredByFlowOutputFieldDocument = exports.FlowDownstreamDatasourcesDocument = exports.FlowDownstreamDatasourcesFilteredByFlowOutputFieldDocument = exports.FlowDownstreamDatabasesDocument = exports.FlowDownstreamDatabasesFilteredByFlowOutputFieldDocument = exports.FlowDownstreamDashboardsDocument = exports.FlowDownstreamDashboardsFilteredByFlowOutputFieldDocument = exports.FieldsReferencedByFieldDocument = exports.FieldDetailsDocument = exports.DownstreamWorkbooksFilteredByFieldDocument = exports.DownstreamTablesFilteredByFieldDocument = exports.DownstreamSheetsFilteredByFieldDocument = exports.DownstreamOwnersFilteredByFieldDocument = exports.DownstreamOwnerIdsFilteredByFieldDocument = exports.DownstreamMetricsFilteredByFieldDocument = exports.DownstreamFlowsFilteredByFieldDocument = exports.DownstreamDatasourcesFilteredByFieldDocument = exports.DownstreamDatabasesFilteredByFieldDocument = void 0;
exports.TableDownstreamSheetsFilteredByColumnDocument = exports.TableDownstreamPublishedDatasourcesDocument = exports.TableDownstreamPublishedDatasourcesFilteredByColumnDocument = exports.TableDownstreamOwnersDocument = exports.TableDownstreamOwnersFilteredByColumnDocument = exports.TableDownstreamOwnerIdsDocument = exports.TableDownstreamOwnerIdsFilteredByColumnDocument = exports.TableDownstreamMetricsDocument = exports.TableDownstreamMetricsFilteredByColumnDocument = exports.TableDownstreamLensesDocument = exports.TableDownstreamLensesFilteredByColumnDocument = exports.TableDownstreamFlowsDocument = exports.TableDownstreamFlowsFilteredByColumnDocument = exports.TableDownstreamDatabasesDocument = exports.TableDownstreamDatabasesFilteredByColumnDocument = exports.TableDownstreamDashboardsDocument = exports.TableDownstreamDashboardsFilteredByColumnDocument = exports.TableColumnsByIdDocument = exports.SiteDocument = exports.LensUpstreamVirtualConnectionsDocument = exports.LensUpstreamVirtualConnectionTablesDocument = exports.LensUpstreamTablesDocument = exports.LensUpstreamFlowsDocument = exports.LensUpstreamDatasourcesDocument = exports.LensUpstreamDatabasesDocument = exports.LensDocument = exports.LensLineageCountsDocument = exports.LensFieldsByIdDocument = exports.LensFieldDetailsDocument = exports.LensDownstreamWorkbooksDocument = exports.LensDownstreamOwnersDocument = exports.LensDownstreamOwnerIdsDocument = exports.LensDownstreamMetricsDocument = exports.LensDownstreamDashboardsDocument = exports.LabelValueDeleteCountsDocument = exports.GetUserDocument = exports.MetricLineageLabelsDocument = exports.FlowFieldLineageLabelsDocument = exports.FlowColumnFieldLineageLabelsDocument = exports.FieldLineageLabelsDocument = exports.WorkbookLineageLabelsDocument = exports.ViewLineageLabelsDocument = exports.EmbeddedDatasourceLineageLabelsDocument = exports.PublishedDatasourceLineageLabelsDocument = exports.FlowLineageLabelsDocument = exports.ColumnLineageLabelsDocument = exports.VirtualConnectionTablesLineageLabelsDocument = exports.VirtualConnectionLineageLabelsDocument = exports.DatabaseTableLineageLabelsDocument = exports.DatabaseLineageLabelsDocument = void 0;
exports.VirtualConnectionLineageCountsDocument = exports.VirtualConnectionLineageCountsFilteredByTableDocument = exports.VirtualConnectionDownstreamWorkbooksDocument = exports.VirtualConnectionDownstreamWorkbooksFilteredByTableDocument = exports.VirtualConnectionDownstreamSheetsDocument = exports.VirtualConnectionDownstreamSheetsFilteredByTableDocument = exports.VirtualConnectionDownstreamOwnersDocument = exports.VirtualConnectionDownstreamOwnersFilteredByTableDocument = exports.VirtualConnectionDownstreamOwnerIdsDocument = exports.VirtualConnectionDownstreamOwnerIdsFilteredByColumnDocument = exports.VirtualConnectionDownstreamMetricsDocument = exports.VirtualConnectionDownstreamMetricsFilteredByTableDocument = exports.VirtualConnectionDownstreamLensesDocument = exports.VirtualConnectionDownstreamLensesFilteredByTableDocument = exports.VirtualConnectionDownstreamFlowsDocument = exports.VirtualConnectionDownstreamFlowsFilteredByTableDocument = exports.VirtualConnectionDownstreamDatasourcesDocument = exports.VirtualConnectionDownstreamDatasourcesFilteredByTableDocument = exports.VirtualConnectionDownstreamDashboardsDocument = exports.VirtualConnectionDownstreamDashboardsFilteredByTableDocument = exports.ViewDetailsByPathDocument = exports.UpstreamVirtualConnectionsFilteredByFieldDocument = exports.UpstreamVirtualConnectionTablesFilteredByFieldDocument = exports.UpstreamTablesFilteredByFieldDocument = exports.UpstreamFlowsFilteredByFieldDocument = exports.UpstreamDatasourcesFilteredByFieldDocument = exports.UpstreamDatabasesFilteredByFieldDocument = exports.TagsQueryWithFiltersDocument = exports.TablesDocument = exports.TablesByTagDocument = exports.TableUpstreamTablesDocument = exports.TableUpstreamTablesFilteredByColumnDocument = exports.TableUpstreamFlowsDocument = exports.TableUpstreamFlowsFilteredByColumnDocument = exports.TableUpstreamDatasourcesDocument = exports.TableUpstreamDatasourcesFilteredByColumnDocument = exports.TableUpstreamDatabasesDocument = exports.TableUpstreamDatabasesFilteredByColumnDocument = exports.TableDocument = exports.TableLineageCountsDocument = exports.TableLineageCountsFilteredByColumnDocument = exports.TableDownstreamWorkbooksDocument = exports.TableDownstreamWorkbooksFilteredByColumnDocument = exports.TableDownstreamVirtualConnectionsDocument = exports.TableDownstreamVirtualConnectionsFilteredByColumnDocument = exports.TableDownstreamVirtualConnectionTablesDocument = exports.TableDownstreamVirtualConnectionTablesFilteredByColumnDocument = exports.TableDownstreamTablesDocument = exports.TableDownstreamTablesFilteredByColumnDocument = exports.TableDownstreamSheetsDocument = void 0;
exports.WorkbookUpstreamVirtualConnectionsDocument = exports.WorkbookUpstreamVirtualConnectionTablesDocument = exports.WorkbookUpstreamTablesDocument = exports.WorkbookUpstreamLensesDocument = exports.WorkbookUpstreamFlowsDocument = exports.WorkbookUpstreamDatasourcesDocument = exports.WorkbookUpstreamDatabasesDocument = exports.WorkbookDocument = exports.WorkbookLineageCountsDocument = exports.WorkbookLineageCountsFilteredByFieldDocument = exports.WorkbookFieldsByIdDocument = exports.WorkbookDownstreamSheetsDocument = exports.WorkbookDownstreamOwnersDocument = exports.WorkbookDownstreamOwnerIdsDocument = exports.WorkbookDownstreamMetricsDocument = exports.WorkbookDownstreamDashboardsDocument = exports.VirtualConnectionUpstreamTablesDocument = exports.VirtualConnectionUpstreamTablesFilteredByTableDocument = exports.VirtualConnectionUpstreamDatabasesDocument = exports.VirtualConnectionUpstreamDatabasesFilteredByTableDocument = exports.VirtualConnectionTablesByIdDocument = exports.VirtualConnectionTableUpstreamVirtualConnectionsDocument = exports.VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnDocument = exports.VirtualConnectionTableUpstreamTablesDocument = exports.VirtualConnectionTableUpstreamTablesFilteredByColumnDocument = exports.VirtualConnectionTableUpstreamDatabasesDocument = exports.VirtualConnectionTableUpstreamDatabasesFilteredByColumnDocument = exports.VirtualConnectionTableDocument = exports.VirtualConnectionTableLineageCountsDocument = exports.VirtualConnectionTableLineageCountsFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamWorkbooksDocument = exports.VirtualConnectionTableDownstreamWorkbooksFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamSheetsDocument = exports.VirtualConnectionTableDownstreamSheetsFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamOwnersDocument = exports.VirtualConnectionTableDownstreamOwnersFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamOwnerIdsDocument = exports.VirtualConnectionTableDownstreamOwnerIdsFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamMetricsDocument = exports.VirtualConnectionTableDownstreamMetricsFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamLensesDocument = exports.VirtualConnectionTableDownstreamLensesFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamFlowsDocument = exports.VirtualConnectionTableDownstreamFlowsFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamDatasourcesDocument = exports.VirtualConnectionTableDownstreamDatasourcesFilteredByColumnDocument = exports.VirtualConnectionTableDownstreamDashboardsDocument = exports.VirtualConnectionTableDownstreamDashboardsFilteredByColumnDocument = exports.VirtualConnectionTableColumnsByIdDocument = exports.VirtualConnectionDocument = void 0;
const client_1 = require("@apollo/client");
/** Enum for fields that can be used for sorting */
var AnalyticsFieldOrderField;
(function (AnalyticsFieldOrderField) {
    /** Sort by id */
    AnalyticsFieldOrderField["ID"] = "ID";
})(AnalyticsFieldOrderField = exports.AnalyticsFieldOrderField || (exports.AnalyticsFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var AskDataExtensionOrderField;
(function (AskDataExtensionOrderField) {
    /** Sort by id */
    AskDataExtensionOrderField["ID"] = "ID";
})(AskDataExtensionOrderField = exports.AskDataExtensionOrderField || (exports.AskDataExtensionOrderField = {}));
/** Enum for fields that can be used for sorting */
var BinFieldOrderField;
(function (BinFieldOrderField) {
    /** Sort by dataCategory */
    BinFieldOrderField["DATA_CATEGORY"] = "DATA_CATEGORY";
    /** Sort by dataType */
    BinFieldOrderField["DATA_TYPE"] = "DATA_TYPE";
    /** Sort by downstreamSheets count */
    BinFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by fields count */
    BinFieldOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    BinFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    BinFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    BinFieldOrderField["NAME"] = "NAME";
    /** Sort by role */
    BinFieldOrderField["ROLE"] = "ROLE";
})(BinFieldOrderField = exports.BinFieldOrderField || (exports.BinFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var CalculatedFieldOrderField;
(function (CalculatedFieldOrderField) {
    /** Sort by dataCategory */
    CalculatedFieldOrderField["DATA_CATEGORY"] = "DATA_CATEGORY";
    /** Sort by dataType */
    CalculatedFieldOrderField["DATA_TYPE"] = "DATA_TYPE";
    /** Sort by downstreamSheets count */
    CalculatedFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by fields count */
    CalculatedFieldOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    CalculatedFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    CalculatedFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    CalculatedFieldOrderField["NAME"] = "NAME";
    /** Sort by role */
    CalculatedFieldOrderField["ROLE"] = "ROLE";
})(CalculatedFieldOrderField = exports.CalculatedFieldOrderField || (exports.CalculatedFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var CanHaveLabelsOrderField;
(function (CanHaveLabelsOrderField) {
    /** Sort by id */
    CanHaveLabelsOrderField["ID"] = "ID";
    /** Sort by luid */
    CanHaveLabelsOrderField["LUID"] = "LUID";
})(CanHaveLabelsOrderField = exports.CanHaveLabelsOrderField || (exports.CanHaveLabelsOrderField = {}));
/** Enum for fields that can be used for sorting */
var CertifiableOrderField;
(function (CertifiableOrderField) {
    /** Sort by id */
    CertifiableOrderField["ID"] = "ID";
    /** Sort by isCertified */
    CertifiableOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by luid */
    CertifiableOrderField["LUID"] = "LUID";
})(CertifiableOrderField = exports.CertifiableOrderField || (exports.CertifiableOrderField = {}));
/** Enum for fields that can be used for sorting */
var CloudFileOrderField;
(function (CloudFileOrderField) {
    /** Sort by connectionType */
    CloudFileOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    /** Sort by downstreamDatasources count */
    CloudFileOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamVirtualConnections count */
    CloudFileOrderField["DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT"] = "DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT";
    /** Sort by downstreamWorkbooks count */
    CloudFileOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by hasActiveWarning */
    CloudFileOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    CloudFileOrderField["ID"] = "ID";
    /** Sort by isCertified */
    CloudFileOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by isEmbedded */
    CloudFileOrderField["IS_EMBEDDED"] = "IS_EMBEDDED";
    /** Sort by luid */
    CloudFileOrderField["LUID"] = "LUID";
    /** Sort by name */
    CloudFileOrderField["NAME"] = "NAME";
    /** Sort by projectName */
    CloudFileOrderField["PROJECT_NAME"] = "PROJECT_NAME";
})(CloudFileOrderField = exports.CloudFileOrderField || (exports.CloudFileOrderField = {}));
/** Enum for fields that can be used for sorting */
var ColumnFieldOrderField;
(function (ColumnFieldOrderField) {
    /** Sort by dataCategory */
    ColumnFieldOrderField["DATA_CATEGORY"] = "DATA_CATEGORY";
    /** Sort by dataType */
    ColumnFieldOrderField["DATA_TYPE"] = "DATA_TYPE";
    /** Sort by downstreamSheets count */
    ColumnFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by id */
    ColumnFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    ColumnFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    ColumnFieldOrderField["NAME"] = "NAME";
    /** Sort by role */
    ColumnFieldOrderField["ROLE"] = "ROLE";
})(ColumnFieldOrderField = exports.ColumnFieldOrderField || (exports.ColumnFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var ColumnOrderField;
(function (ColumnOrderField) {
    /** Sort by hasActiveWarning */
    ColumnOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    ColumnOrderField["ID"] = "ID";
    /** Sort by luid */
    ColumnOrderField["LUID"] = "LUID";
    /** Sort by name */
    ColumnOrderField["NAME"] = "NAME";
})(ColumnOrderField = exports.ColumnOrderField || (exports.ColumnOrderField = {}));
/** Enum for fields that can be used for sorting */
var CombinedFieldOrderField;
(function (CombinedFieldOrderField) {
    /** Sort by downstreamSheets count */
    CombinedFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by fields count */
    CombinedFieldOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    CombinedFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    CombinedFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    CombinedFieldOrderField["NAME"] = "NAME";
})(CombinedFieldOrderField = exports.CombinedFieldOrderField || (exports.CombinedFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var CombinedSetFieldOrderField;
(function (CombinedSetFieldOrderField) {
    /** Sort by downstreamSheets count */
    CombinedSetFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by fields count */
    CombinedSetFieldOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    CombinedSetFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    CombinedSetFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    CombinedSetFieldOrderField["NAME"] = "NAME";
})(CombinedSetFieldOrderField = exports.CombinedSetFieldOrderField || (exports.CombinedSetFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var CustomSqlTableOrderField;
(function (CustomSqlTableOrderField) {
    /** Sort by columns count */
    CustomSqlTableOrderField["COLUMNS_COUNT"] = "COLUMNS_COUNT";
    /** Sort by downstreamDashboards count */
    CustomSqlTableOrderField["DOWNSTREAM_DASHBOARDS_COUNT"] = "DOWNSTREAM_DASHBOARDS_COUNT";
    /** Sort by downstreamDatasources count */
    CustomSqlTableOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamWorkbooks count */
    CustomSqlTableOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by id */
    CustomSqlTableOrderField["ID"] = "ID";
    /** Sort by isUnsupportedCustomSql */
    CustomSqlTableOrderField["IS_UNSUPPORTED_CUSTOM_SQL"] = "IS_UNSUPPORTED_CUSTOM_SQL";
    /** Sort by name */
    CustomSqlTableOrderField["NAME"] = "NAME";
})(CustomSqlTableOrderField = exports.CustomSqlTableOrderField || (exports.CustomSqlTableOrderField = {}));
/** Enum for fields that can be used for sorting */
var DashboardOrderField;
(function (DashboardOrderField) {
    /** Sort by documentViewId */
    DashboardOrderField["DOCUMENT_VIEW_ID"] = "DOCUMENT_VIEW_ID";
    /** Sort by id */
    DashboardOrderField["ID"] = "ID";
    /** Sort by luid */
    DashboardOrderField["LUID"] = "LUID";
    /** Sort by name */
    DashboardOrderField["NAME"] = "NAME";
    /** Sort by path */
    DashboardOrderField["PATH"] = "PATH";
})(DashboardOrderField = exports.DashboardOrderField || (exports.DashboardOrderField = {}));
/** Enum for fields that can be used for sorting */
var DataFieldOrderField;
(function (DataFieldOrderField) {
    /** Sort by dataCategory */
    DataFieldOrderField["DATA_CATEGORY"] = "DATA_CATEGORY";
    /** Sort by dataType */
    DataFieldOrderField["DATA_TYPE"] = "DATA_TYPE";
    /** Sort by id */
    DataFieldOrderField["ID"] = "ID";
    /** Sort by role */
    DataFieldOrderField["ROLE"] = "ROLE";
})(DataFieldOrderField = exports.DataFieldOrderField || (exports.DataFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var DataQualityCertificationOrderField;
(function (DataQualityCertificationOrderField) {
    /** Sort by category */
    DataQualityCertificationOrderField["CATEGORY"] = "CATEGORY";
    /** Sort by id */
    DataQualityCertificationOrderField["ID"] = "ID";
    /** Sort by isActive */
    DataQualityCertificationOrderField["IS_ACTIVE"] = "IS_ACTIVE";
    /** Sort by isElevated */
    DataQualityCertificationOrderField["IS_ELEVATED"] = "IS_ELEVATED";
    /** Sort by luid */
    DataQualityCertificationOrderField["LUID"] = "LUID";
    /** Sort by value */
    DataQualityCertificationOrderField["VALUE"] = "VALUE";
})(DataQualityCertificationOrderField = exports.DataQualityCertificationOrderField || (exports.DataQualityCertificationOrderField = {}));
/** Enum for fields that can be used for sorting */
var DataQualityWarningOrderField;
(function (DataQualityWarningOrderField) {
    /** Sort by category */
    DataQualityWarningOrderField["CATEGORY"] = "CATEGORY";
    /** Sort by id */
    DataQualityWarningOrderField["ID"] = "ID";
    /** Sort by isActive */
    DataQualityWarningOrderField["IS_ACTIVE"] = "IS_ACTIVE";
    /** Sort by isElevated */
    DataQualityWarningOrderField["IS_ELEVATED"] = "IS_ELEVATED";
    /** Sort by isSevere */
    DataQualityWarningOrderField["IS_SEVERE"] = "IS_SEVERE";
    /** Sort by luid */
    DataQualityWarningOrderField["LUID"] = "LUID";
    /** Sort by value */
    DataQualityWarningOrderField["VALUE"] = "VALUE";
    /** Sort by warningType */
    DataQualityWarningOrderField["WARNING_TYPE"] = "WARNING_TYPE";
})(DataQualityWarningOrderField = exports.DataQualityWarningOrderField || (exports.DataQualityWarningOrderField = {}));
/** Enum for fields that can be used for sorting */
var DatabaseOrderField;
(function (DatabaseOrderField) {
    /** Sort by connectionType */
    DatabaseOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    /** Sort by downstreamDatasources count */
    DatabaseOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamVirtualConnections count */
    DatabaseOrderField["DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT"] = "DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT";
    /** Sort by downstreamWorkbooks count */
    DatabaseOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by hasActiveWarning */
    DatabaseOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    DatabaseOrderField["ID"] = "ID";
    /** Sort by isCertified */
    DatabaseOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by isEmbedded */
    DatabaseOrderField["IS_EMBEDDED"] = "IS_EMBEDDED";
    /** Sort by luid */
    DatabaseOrderField["LUID"] = "LUID";
    /** Sort by name */
    DatabaseOrderField["NAME"] = "NAME";
    /** Sort by projectName */
    DatabaseOrderField["PROJECT_NAME"] = "PROJECT_NAME";
})(DatabaseOrderField = exports.DatabaseOrderField || (exports.DatabaseOrderField = {}));
/** Enum for fields that can be used for sorting */
var DatabaseServerOrderField;
(function (DatabaseServerOrderField) {
    /** Sort by connectionType */
    DatabaseServerOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    /** Sort by downstreamDatasources count */
    DatabaseServerOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamVirtualConnections count */
    DatabaseServerOrderField["DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT"] = "DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT";
    /** Sort by downstreamWorkbooks count */
    DatabaseServerOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by hasActiveWarning */
    DatabaseServerOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by hostName */
    DatabaseServerOrderField["HOST_NAME"] = "HOST_NAME";
    /** Sort by id */
    DatabaseServerOrderField["ID"] = "ID";
    /** Sort by isCertified */
    DatabaseServerOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by isEmbedded */
    DatabaseServerOrderField["IS_EMBEDDED"] = "IS_EMBEDDED";
    /** Sort by luid */
    DatabaseServerOrderField["LUID"] = "LUID";
    /** Sort by name */
    DatabaseServerOrderField["NAME"] = "NAME";
    /** Sort by projectName */
    DatabaseServerOrderField["PROJECT_NAME"] = "PROJECT_NAME";
})(DatabaseServerOrderField = exports.DatabaseServerOrderField || (exports.DatabaseServerOrderField = {}));
/** Enum for fields that can be used for sorting */
var DatabaseTableOrderField;
(function (DatabaseTableOrderField) {
    /** Sort by columns count */
    DatabaseTableOrderField["COLUMNS_COUNT"] = "COLUMNS_COUNT";
    /** Sort by connectionType */
    DatabaseTableOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    /** Sort by downstreamDashboards count */
    DatabaseTableOrderField["DOWNSTREAM_DASHBOARDS_COUNT"] = "DOWNSTREAM_DASHBOARDS_COUNT";
    /** Sort by downstreamDatasources count */
    DatabaseTableOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamVirtualConnections count */
    DatabaseTableOrderField["DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT"] = "DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT";
    /** Sort by downstreamWorkbooks count */
    DatabaseTableOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by fullName */
    DatabaseTableOrderField["FULL_NAME"] = "FULL_NAME";
    /** Sort by hasActiveWarning */
    DatabaseTableOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    DatabaseTableOrderField["ID"] = "ID";
    /** Sort by isCertified */
    DatabaseTableOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by isEmbedded */
    DatabaseTableOrderField["IS_EMBEDDED"] = "IS_EMBEDDED";
    /** Sort by luid */
    DatabaseTableOrderField["LUID"] = "LUID";
    /** Sort by name */
    DatabaseTableOrderField["NAME"] = "NAME";
    /** Sort by projectName */
    DatabaseTableOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    /** Sort by schema */
    DatabaseTableOrderField["SCHEMA"] = "SCHEMA";
})(DatabaseTableOrderField = exports.DatabaseTableOrderField || (exports.DatabaseTableOrderField = {}));
/** Enum for fields that can be used for sorting */
var DatasourceFieldOrderField;
(function (DatasourceFieldOrderField) {
    /** Sort by downstreamSheets count */
    DatasourceFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by id */
    DatasourceFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    DatasourceFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    DatasourceFieldOrderField["NAME"] = "NAME";
})(DatasourceFieldOrderField = exports.DatasourceFieldOrderField || (exports.DatasourceFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var DatasourceFilterOrderField;
(function (DatasourceFilterOrderField) {
    /** Sort by id */
    DatasourceFilterOrderField["ID"] = "ID";
})(DatasourceFilterOrderField = exports.DatasourceFilterOrderField || (exports.DatasourceFilterOrderField = {}));
/** Enum for fields that can be used for sorting */
var DatasourceOrderField;
(function (DatasourceOrderField) {
    /** Sort by containsUnsupportedCustomSql */
    DatasourceOrderField["CONTAINS_UNSUPPORTED_CUSTOM_SQL"] = "CONTAINS_UNSUPPORTED_CUSTOM_SQL";
    /** Sort by downstreamOwners count */
    DatasourceOrderField["DOWNSTREAM_OWNERS_COUNT"] = "DOWNSTREAM_OWNERS_COUNT";
    /** Sort by downstreamWorkbooks count */
    DatasourceOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by fields count */
    DatasourceOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    DatasourceOrderField["ID"] = "ID";
    /** Sort by name */
    DatasourceOrderField["NAME"] = "NAME";
})(DatasourceOrderField = exports.DatasourceOrderField || (exports.DatasourceOrderField = {}));
/** Enum for fields that can be used for sorting */
var EmbeddedDatasourceOrderField;
(function (EmbeddedDatasourceOrderField) {
    /** Sort by containsUnsupportedCustomSql */
    EmbeddedDatasourceOrderField["CONTAINS_UNSUPPORTED_CUSTOM_SQL"] = "CONTAINS_UNSUPPORTED_CUSTOM_SQL";
    /** Sort by downstreamOwners count */
    EmbeddedDatasourceOrderField["DOWNSTREAM_OWNERS_COUNT"] = "DOWNSTREAM_OWNERS_COUNT";
    /** Sort by downstreamWorkbooks count */
    EmbeddedDatasourceOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by fields count */
    EmbeddedDatasourceOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    EmbeddedDatasourceOrderField["ID"] = "ID";
    /** Sort by name */
    EmbeddedDatasourceOrderField["NAME"] = "NAME";
})(EmbeddedDatasourceOrderField = exports.EmbeddedDatasourceOrderField || (exports.EmbeddedDatasourceOrderField = {}));
/** Possible types of extract */
var ExtractType;
(function (ExtractType) {
    ExtractType["FULL"] = "FULL";
    ExtractType["INCREMENTAL"] = "INCREMENTAL";
})(ExtractType = exports.ExtractType || (exports.ExtractType = {}));
/** Possible data types for a field. */
var FieldDataType;
(function (FieldDataType) {
    FieldDataType["BOOLEAN"] = "BOOLEAN";
    FieldDataType["DATE"] = "DATE";
    FieldDataType["DATETIME"] = "DATETIME";
    FieldDataType["INTEGER"] = "INTEGER";
    FieldDataType["REAL"] = "REAL";
    FieldDataType["SPATIAL"] = "SPATIAL";
    FieldDataType["STRING"] = "STRING";
    FieldDataType["TABLE"] = "TABLE";
    FieldDataType["TUPLE"] = "TUPLE";
    FieldDataType["UNKNOWN"] = "UNKNOWN";
})(FieldDataType = exports.FieldDataType || (exports.FieldDataType = {}));
/** Enum for fields that can be used for sorting */
var FieldOrderField;
(function (FieldOrderField) {
    /** Sort by downstreamSheets count */
    FieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by id */
    FieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    FieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    FieldOrderField["NAME"] = "NAME";
})(FieldOrderField = exports.FieldOrderField || (exports.FieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var FieldReferencingFieldOrderField;
(function (FieldReferencingFieldOrderField) {
    /** Sort by fields count */
    FieldReferencingFieldOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    FieldReferencingFieldOrderField["ID"] = "ID";
})(FieldReferencingFieldOrderField = exports.FieldReferencingFieldOrderField || (exports.FieldReferencingFieldOrderField = {}));
/** Possible roles of a field. */
var FieldRole;
(function (FieldRole) {
    FieldRole["DIMENSION"] = "DIMENSION";
    FieldRole["MEASURE"] = "MEASURE";
    FieldRole["UNKNOWN"] = "UNKNOWN";
})(FieldRole = exports.FieldRole || (exports.FieldRole = {}));
/** Possible categories of a field role. */
var FieldRoleCategory;
(function (FieldRoleCategory) {
    FieldRoleCategory["NOMINAL"] = "NOMINAL";
    FieldRoleCategory["ORDINAL"] = "ORDINAL";
    FieldRoleCategory["QUANTITATIVE"] = "QUANTITATIVE";
    FieldRoleCategory["UNKNOWN"] = "UNKNOWN";
})(FieldRoleCategory = exports.FieldRoleCategory || (exports.FieldRoleCategory = {}));
/** Enum for fields that can be used for sorting */
var FileOrderField;
(function (FileOrderField) {
    /** Sort by connectionType */
    FileOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    /** Sort by downstreamDatasources count */
    FileOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamVirtualConnections count */
    FileOrderField["DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT"] = "DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT";
    /** Sort by downstreamWorkbooks count */
    FileOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by hasActiveWarning */
    FileOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    FileOrderField["ID"] = "ID";
    /** Sort by isCertified */
    FileOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by isEmbedded */
    FileOrderField["IS_EMBEDDED"] = "IS_EMBEDDED";
    /** Sort by luid */
    FileOrderField["LUID"] = "LUID";
    /** Sort by name */
    FileOrderField["NAME"] = "NAME";
    /** Sort by projectName */
    FileOrderField["PROJECT_NAME"] = "PROJECT_NAME";
})(FileOrderField = exports.FileOrderField || (exports.FileOrderField = {}));
/** Enum for fields that can be used for sorting */
var FlowColumnInputFieldOrderField;
(function (FlowColumnInputFieldOrderField) {
    /** Sort by id */
    FlowColumnInputFieldOrderField["ID"] = "ID";
    /** Sort by name */
    FlowColumnInputFieldOrderField["NAME"] = "NAME";
})(FlowColumnInputFieldOrderField = exports.FlowColumnInputFieldOrderField || (exports.FlowColumnInputFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var FlowColumnOutputFieldOrderField;
(function (FlowColumnOutputFieldOrderField) {
    /** Sort by id */
    FlowColumnOutputFieldOrderField["ID"] = "ID";
    /** Sort by name */
    FlowColumnOutputFieldOrderField["NAME"] = "NAME";
})(FlowColumnOutputFieldOrderField = exports.FlowColumnOutputFieldOrderField || (exports.FlowColumnOutputFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var FlowFieldInputFieldOrderField;
(function (FlowFieldInputFieldOrderField) {
    /** Sort by id */
    FlowFieldInputFieldOrderField["ID"] = "ID";
    /** Sort by name */
    FlowFieldInputFieldOrderField["NAME"] = "NAME";
})(FlowFieldInputFieldOrderField = exports.FlowFieldInputFieldOrderField || (exports.FlowFieldInputFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var FlowFieldOutputFieldOrderField;
(function (FlowFieldOutputFieldOrderField) {
    /** Sort by id */
    FlowFieldOutputFieldOrderField["ID"] = "ID";
    /** Sort by name */
    FlowFieldOutputFieldOrderField["NAME"] = "NAME";
})(FlowFieldOutputFieldOrderField = exports.FlowFieldOutputFieldOrderField || (exports.FlowFieldOutputFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var FlowInputFieldOrderField;
(function (FlowInputFieldOrderField) {
    /** Sort by id */
    FlowInputFieldOrderField["ID"] = "ID";
    /** Sort by name */
    FlowInputFieldOrderField["NAME"] = "NAME";
})(FlowInputFieldOrderField = exports.FlowInputFieldOrderField || (exports.FlowInputFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var FlowOrderField;
(function (FlowOrderField) {
    /** Sort by containerName */
    FlowOrderField["CONTAINER_NAME"] = "CONTAINER_NAME";
    /** Sort by containsUnsupportedCustomSql */
    FlowOrderField["CONTAINS_UNSUPPORTED_CUSTOM_SQL"] = "CONTAINS_UNSUPPORTED_CUSTOM_SQL";
    /** Sort by hasActiveWarning */
    FlowOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    FlowOrderField["ID"] = "ID";
    /** Sort by luid */
    FlowOrderField["LUID"] = "LUID";
    /** Sort by name */
    FlowOrderField["NAME"] = "NAME";
    /** Sort by projectName */
    FlowOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    /** Sort by vizportalUrlId */
    FlowOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(FlowOrderField = exports.FlowOrderField || (exports.FlowOrderField = {}));
/** Enum for fields that can be used for sorting */
var FlowOutputFieldOrderField;
(function (FlowOutputFieldOrderField) {
    /** Sort by id */
    FlowOutputFieldOrderField["ID"] = "ID";
    /** Sort by name */
    FlowOutputFieldOrderField["NAME"] = "NAME";
})(FlowOutputFieldOrderField = exports.FlowOutputFieldOrderField || (exports.FlowOutputFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var FlowOutputStepOrderField;
(function (FlowOutputStepOrderField) {
    /** Sort by id */
    FlowOutputStepOrderField["ID"] = "ID";
    /** Sort by name */
    FlowOutputStepOrderField["NAME"] = "NAME";
})(FlowOutputStepOrderField = exports.FlowOutputStepOrderField || (exports.FlowOutputStepOrderField = {}));
/** Enum for fields that can be used for sorting */
var GenericLabelOrderField;
(function (GenericLabelOrderField) {
    /** Sort by category */
    GenericLabelOrderField["CATEGORY"] = "CATEGORY";
    /** Sort by id */
    GenericLabelOrderField["ID"] = "ID";
    /** Sort by isActive */
    GenericLabelOrderField["IS_ACTIVE"] = "IS_ACTIVE";
    /** Sort by isElevated */
    GenericLabelOrderField["IS_ELEVATED"] = "IS_ELEVATED";
    /** Sort by luid */
    GenericLabelOrderField["LUID"] = "LUID";
    /** Sort by value */
    GenericLabelOrderField["VALUE"] = "VALUE";
})(GenericLabelOrderField = exports.GenericLabelOrderField || (exports.GenericLabelOrderField = {}));
/** Enum for fields that can be used for sorting */
var GroupFieldOrderField;
(function (GroupFieldOrderField) {
    /** Sort by dataCategory */
    GroupFieldOrderField["DATA_CATEGORY"] = "DATA_CATEGORY";
    /** Sort by dataType */
    GroupFieldOrderField["DATA_TYPE"] = "DATA_TYPE";
    /** Sort by downstreamSheets count */
    GroupFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by fields count */
    GroupFieldOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    GroupFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    GroupFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    GroupFieldOrderField["NAME"] = "NAME";
    /** Sort by role */
    GroupFieldOrderField["ROLE"] = "ROLE";
})(GroupFieldOrderField = exports.GroupFieldOrderField || (exports.GroupFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var HierarchyFieldOrderField;
(function (HierarchyFieldOrderField) {
    /** Sort by downstreamSheets count */
    HierarchyFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by fields count */
    HierarchyFieldOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    HierarchyFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    HierarchyFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    HierarchyFieldOrderField["NAME"] = "NAME";
})(HierarchyFieldOrderField = exports.HierarchyFieldOrderField || (exports.HierarchyFieldOrderField = {}));
/** Method of selecting the objects (i.e., inheritance sources) to inherit from */
var InheritanceType;
(function (InheritanceType) {
    /** Inherit from the closest unambiguous upstream object */
    InheritanceType["FIRST"] = "FIRST";
})(InheritanceType = exports.InheritanceType || (exports.InheritanceType = {}));
/** Enum for fields that can be used for sorting */
var LabelOrderField;
(function (LabelOrderField) {
    /** Sort by category */
    LabelOrderField["CATEGORY"] = "CATEGORY";
    /** Sort by id */
    LabelOrderField["ID"] = "ID";
    /** Sort by isActive */
    LabelOrderField["IS_ACTIVE"] = "IS_ACTIVE";
    /** Sort by isElevated */
    LabelOrderField["IS_ELEVATED"] = "IS_ELEVATED";
    /** Sort by luid */
    LabelOrderField["LUID"] = "LUID";
    /** Sort by value */
    LabelOrderField["VALUE"] = "VALUE";
})(LabelOrderField = exports.LabelOrderField || (exports.LabelOrderField = {}));
/** Enum for fields that can be used for sorting */
var LensFieldOrderField;
(function (LensFieldOrderField) {
    /** Sort by id */
    LensFieldOrderField["ID"] = "ID";
    /** Sort by name */
    LensFieldOrderField["NAME"] = "NAME";
})(LensFieldOrderField = exports.LensFieldOrderField || (exports.LensFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var LensOrderField;
(function (LensOrderField) {
    /** Sort by fields count */
    LensOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    LensOrderField["ID"] = "ID";
    /** Sort by luid */
    LensOrderField["LUID"] = "LUID";
    /** Sort by name */
    LensOrderField["NAME"] = "NAME";
    /** Sort by owner count */
    LensOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    /** Sort by vizportalUrlId */
    LensOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(LensOrderField = exports.LensOrderField || (exports.LensOrderField = {}));
/** Enum for fields that can be used for sorting */
var LinkedFlowOrderField;
(function (LinkedFlowOrderField) {
    /** Sort by id */
    LinkedFlowOrderField["ID"] = "ID";
})(LinkedFlowOrderField = exports.LinkedFlowOrderField || (exports.LinkedFlowOrderField = {}));
/** Enum for fields that can be used for sorting */
var MetricOrderField;
(function (MetricOrderField) {
    /** Sort by containerName */
    MetricOrderField["CONTAINER_NAME"] = "CONTAINER_NAME";
    /** Sort by id */
    MetricOrderField["ID"] = "ID";
    /** Sort by luid */
    MetricOrderField["LUID"] = "LUID";
    /** Sort by name */
    MetricOrderField["NAME"] = "NAME";
    /** Sort by owner count */
    MetricOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    /** Sort by projectName */
    MetricOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    /** Sort by vizportalUrlId */
    MetricOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(MetricOrderField = exports.MetricOrderField || (exports.MetricOrderField = {}));
/** Enum for fields that can be used for sorting */
var NodeOrderField;
(function (NodeOrderField) {
    /** Sort by id */
    NodeOrderField["ID"] = "ID";
})(NodeOrderField = exports.NodeOrderField || (exports.NodeOrderField = {}));
/** General object for sorting */
var OrderDirection;
(function (OrderDirection) {
    /** Sort in an ascending order. */
    OrderDirection["ASC"] = "ASC";
    /** Sort in a descending order. */
    OrderDirection["DESC"] = "DESC";
})(OrderDirection = exports.OrderDirection || (exports.OrderDirection = {}));
/** Enum for fields that can be used for sorting */
var ParameterOrderField;
(function (ParameterOrderField) {
    /** Sort by id */
    ParameterOrderField["ID"] = "ID";
    /** Sort by name */
    ParameterOrderField["NAME"] = "NAME";
    /** Sort by parentName */
    ParameterOrderField["PARENT_NAME"] = "PARENT_NAME";
})(ParameterOrderField = exports.ParameterOrderField || (exports.ParameterOrderField = {}));
/** Enum of the different ways to apply permissions. */
var PermissionMode;
(function (PermissionMode) {
    /** Filter out results user is not authorized on. */
    PermissionMode["FILTER_RESULTS"] = "FILTER_RESULTS";
    /** Include results that user is not authorized to view with sensitive information obfuscated. */
    PermissionMode["OBFUSCATE_RESULTS"] = "OBFUSCATE_RESULTS";
})(PermissionMode = exports.PermissionMode || (exports.PermissionMode = {}));
/** Enum for fields that can be used for sorting */
var PublishedDatasourceOrderField;
(function (PublishedDatasourceOrderField) {
    /** Sort by containerName */
    PublishedDatasourceOrderField["CONTAINER_NAME"] = "CONTAINER_NAME";
    /** Sort by containsUnsupportedCustomSql */
    PublishedDatasourceOrderField["CONTAINS_UNSUPPORTED_CUSTOM_SQL"] = "CONTAINS_UNSUPPORTED_CUSTOM_SQL";
    /** Sort by downstreamOwners count */
    PublishedDatasourceOrderField["DOWNSTREAM_OWNERS_COUNT"] = "DOWNSTREAM_OWNERS_COUNT";
    /** Sort by downstreamSheets count */
    PublishedDatasourceOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by downstreamWorkbooks count */
    PublishedDatasourceOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by fields count */
    PublishedDatasourceOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by hasActiveWarning */
    PublishedDatasourceOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    PublishedDatasourceOrderField["ID"] = "ID";
    /** Sort by isCertified */
    PublishedDatasourceOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by luid */
    PublishedDatasourceOrderField["LUID"] = "LUID";
    /** Sort by name */
    PublishedDatasourceOrderField["NAME"] = "NAME";
    /** Sort by owner count */
    PublishedDatasourceOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    /** Sort by projectName */
    PublishedDatasourceOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    /** Sort by vizportalUrlId */
    PublishedDatasourceOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(PublishedDatasourceOrderField = exports.PublishedDatasourceOrderField || (exports.PublishedDatasourceOrderField = {}));
/**
 * Possible types of remote types
 *
 * Types correspond to OLEDB types here: https://referencesource.microsoft.com/#system.data/System/Data/OleDb/OLEDB_Enum.cs,364"
 *
 * Types prefixed with 'WDC' correspond to Tableau's Web Data Connector types:
 * https://tableau.github.io/webdataconnector/docs/api_ref.html#webdataconnectorapi.datatypeenum
 */
var RemoteType;
(function (RemoteType) {
    RemoteType["ARRAY"] = "ARRAY";
    RemoteType["BOOL"] = "BOOL";
    RemoteType["BSTR"] = "BSTR";
    RemoteType["BYREF"] = "BYREF";
    RemoteType["BYTES"] = "BYTES";
    RemoteType["CY"] = "CY";
    RemoteType["DATE"] = "DATE";
    RemoteType["DBDATE"] = "DBDATE";
    RemoteType["DBTIME"] = "DBTIME";
    RemoteType["DBTIMESTAMP"] = "DBTIMESTAMP";
    RemoteType["DECIMAL"] = "DECIMAL";
    RemoteType["EMPTY"] = "EMPTY";
    RemoteType["ERROR"] = "ERROR";
    RemoteType["FILETIME"] = "FILETIME";
    RemoteType["GUID"] = "GUID";
    RemoteType["HCHAPTER"] = "HCHAPTER";
    RemoteType["I1"] = "I1";
    RemoteType["I2"] = "I2";
    RemoteType["I4"] = "I4";
    RemoteType["I8"] = "I8";
    RemoteType["IDISPATCH"] = "IDISPATCH";
    RemoteType["IUNKNOWN"] = "IUNKNOWN";
    RemoteType["NULL"] = "NULL";
    RemoteType["NUMERIC"] = "NUMERIC";
    RemoteType["PROPVARIANT"] = "PROPVARIANT";
    RemoteType["R4"] = "R4";
    RemoteType["R8"] = "R8";
    RemoteType["RESERVED"] = "RESERVED";
    RemoteType["STR"] = "STR";
    RemoteType["UDT"] = "UDT";
    RemoteType["UI1"] = "UI1";
    RemoteType["UI2"] = "UI2";
    RemoteType["UI4"] = "UI4";
    RemoteType["UI8"] = "UI8";
    RemoteType["VARIANT"] = "VARIANT";
    RemoteType["VARNUMERIC"] = "VARNUMERIC";
    RemoteType["VECTOR"] = "VECTOR";
    RemoteType["WDC_BOOL"] = "WDC_BOOL";
    RemoteType["WDC_DATE"] = "WDC_DATE";
    RemoteType["WDC_DATETIME"] = "WDC_DATETIME";
    RemoteType["WDC_FLOAT"] = "WDC_FLOAT";
    RemoteType["WDC_GEOMETRY"] = "WDC_GEOMETRY";
    RemoteType["WDC_INT"] = "WDC_INT";
    RemoteType["WDC_STRING"] = "WDC_STRING";
    RemoteType["WSTR"] = "WSTR";
})(RemoteType = exports.RemoteType || (exports.RemoteType = {}));
/** Enum for fields that can be used for sorting */
var SetFieldOrderField;
(function (SetFieldOrderField) {
    /** Sort by downstreamSheets count */
    SetFieldOrderField["DOWNSTREAM_SHEETS_COUNT"] = "DOWNSTREAM_SHEETS_COUNT";
    /** Sort by fields count */
    SetFieldOrderField["FIELDS_COUNT"] = "FIELDS_COUNT";
    /** Sort by id */
    SetFieldOrderField["ID"] = "ID";
    /** Sort by isHidden */
    SetFieldOrderField["IS_HIDDEN"] = "IS_HIDDEN";
    /** Sort by name */
    SetFieldOrderField["NAME"] = "NAME";
})(SetFieldOrderField = exports.SetFieldOrderField || (exports.SetFieldOrderField = {}));
/** Enum for fields that can be used for sorting */
var SheetOrderField;
(function (SheetOrderField) {
    /** Sort by datasourceFields count */
    SheetOrderField["DATASOURCE_FIELDS_COUNT"] = "DATASOURCE_FIELDS_COUNT";
    /** Sort by documentViewId */
    SheetOrderField["DOCUMENT_VIEW_ID"] = "DOCUMENT_VIEW_ID";
    /** Sort by id */
    SheetOrderField["ID"] = "ID";
    /** Sort by luid */
    SheetOrderField["LUID"] = "LUID";
    /** Sort by name */
    SheetOrderField["NAME"] = "NAME";
    /** Sort by path */
    SheetOrderField["PATH"] = "PATH";
    /** Sort by sheetFieldInstances count */
    SheetOrderField["SHEET_FIELD_INSTANCES_COUNT"] = "SHEET_FIELD_INSTANCES_COUNT";
    /** Sort by worksheetFields count */
    SheetOrderField["WORKSHEET_FIELDS_COUNT"] = "WORKSHEET_FIELDS_COUNT";
})(SheetOrderField = exports.SheetOrderField || (exports.SheetOrderField = {}));
/** Enum for fields that can be used for sorting */
var TableOrderField;
(function (TableOrderField) {
    /** Sort by columns count */
    TableOrderField["COLUMNS_COUNT"] = "COLUMNS_COUNT";
    /** Sort by downstreamDashboards count */
    TableOrderField["DOWNSTREAM_DASHBOARDS_COUNT"] = "DOWNSTREAM_DASHBOARDS_COUNT";
    /** Sort by downstreamDatasources count */
    TableOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamWorkbooks count */
    TableOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by id */
    TableOrderField["ID"] = "ID";
    /** Sort by name */
    TableOrderField["NAME"] = "NAME";
})(TableOrderField = exports.TableOrderField || (exports.TableOrderField = {}));
/** Enum for fields that can be used for sorting */
var TableauSiteOrderField;
(function (TableauSiteOrderField) {
    /** Sort by id */
    TableauSiteOrderField["ID"] = "ID";
    /** Sort by luid */
    TableauSiteOrderField["LUID"] = "LUID";
    /** Sort by name */
    TableauSiteOrderField["NAME"] = "NAME";
})(TableauSiteOrderField = exports.TableauSiteOrderField || (exports.TableauSiteOrderField = {}));
/** Enum for fields that can be used for sorting */
var TableauUserOrderField;
(function (TableauUserOrderField) {
    /** Sort by domain */
    TableauUserOrderField["DOMAIN"] = "DOMAIN";
    /** Sort by email */
    TableauUserOrderField["EMAIL"] = "EMAIL";
    /** Sort by id */
    TableauUserOrderField["ID"] = "ID";
    /** Sort by luid */
    TableauUserOrderField["LUID"] = "LUID";
    /** Sort by name */
    TableauUserOrderField["NAME"] = "NAME";
    /** Sort by username */
    TableauUserOrderField["USERNAME"] = "USERNAME";
})(TableauUserOrderField = exports.TableauUserOrderField || (exports.TableauUserOrderField = {}));
/** Enum for fields that can be used for sorting */
var TagOrderField;
(function (TagOrderField) {
    /** Sort by id */
    TagOrderField["ID"] = "ID";
    /** Sort by name */
    TagOrderField["NAME"] = "NAME";
})(TagOrderField = exports.TagOrderField || (exports.TagOrderField = {}));
/** Enum for fields that can be used for sorting */
var TaggableOrderField;
(function (TaggableOrderField) {
    /** Sort by id */
    TaggableOrderField["ID"] = "ID";
    /** Sort by luid */
    TaggableOrderField["LUID"] = "LUID";
})(TaggableOrderField = exports.TaggableOrderField || (exports.TaggableOrderField = {}));
/** Enum for fields that can be used for sorting */
var ViewOrderField;
(function (ViewOrderField) {
    /** Sort by documentViewId */
    ViewOrderField["DOCUMENT_VIEW_ID"] = "DOCUMENT_VIEW_ID";
    /** Sort by id */
    ViewOrderField["ID"] = "ID";
    /** Sort by luid */
    ViewOrderField["LUID"] = "LUID";
    /** Sort by name */
    ViewOrderField["NAME"] = "NAME";
    /** Sort by path */
    ViewOrderField["PATH"] = "PATH";
})(ViewOrderField = exports.ViewOrderField || (exports.ViewOrderField = {}));
/** Enum for fields that can be used for sorting */
var VirtualConnectionOrderField;
(function (VirtualConnectionOrderField) {
    /** Sort by connectionType */
    VirtualConnectionOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    /** Sort by containerName */
    VirtualConnectionOrderField["CONTAINER_NAME"] = "CONTAINER_NAME";
    /** Sort by downstreamDatasources count */
    VirtualConnectionOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamWorkbooks count */
    VirtualConnectionOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by hasActiveWarning */
    VirtualConnectionOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    VirtualConnectionOrderField["ID"] = "ID";
    /** Sort by isCertified */
    VirtualConnectionOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by luid */
    VirtualConnectionOrderField["LUID"] = "LUID";
    /** Sort by name */
    VirtualConnectionOrderField["NAME"] = "NAME";
    /** Sort by owner count */
    VirtualConnectionOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    /** Sort by projectName */
    VirtualConnectionOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    /** Sort by vizportalUrlId */
    VirtualConnectionOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(VirtualConnectionOrderField = exports.VirtualConnectionOrderField || (exports.VirtualConnectionOrderField = {}));
/** Enum for fields that can be used for sorting */
var VirtualConnectionTableOrderField;
(function (VirtualConnectionTableOrderField) {
    /** Sort by columns count */
    VirtualConnectionTableOrderField["COLUMNS_COUNT"] = "COLUMNS_COUNT";
    /** Sort by containsUnsupportedCustomSql */
    VirtualConnectionTableOrderField["CONTAINS_UNSUPPORTED_CUSTOM_SQL"] = "CONTAINS_UNSUPPORTED_CUSTOM_SQL";
    /** Sort by downstreamDashboards count */
    VirtualConnectionTableOrderField["DOWNSTREAM_DASHBOARDS_COUNT"] = "DOWNSTREAM_DASHBOARDS_COUNT";
    /** Sort by downstreamDatasources count */
    VirtualConnectionTableOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamWorkbooks count */
    VirtualConnectionTableOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by extractLastRefreshedAt */
    VirtualConnectionTableOrderField["EXTRACT_LAST_REFRESHED_AT"] = "EXTRACT_LAST_REFRESHED_AT";
    /** Sort by extractLastRefreshType */
    VirtualConnectionTableOrderField["EXTRACT_LAST_REFRESH_TYPE"] = "EXTRACT_LAST_REFRESH_TYPE";
    /** Sort by hasActiveWarning */
    VirtualConnectionTableOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    VirtualConnectionTableOrderField["ID"] = "ID";
    /** Sort by isCertified */
    VirtualConnectionTableOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by isExtracted */
    VirtualConnectionTableOrderField["IS_EXTRACTED"] = "IS_EXTRACTED";
    /** Sort by luid */
    VirtualConnectionTableOrderField["LUID"] = "LUID";
    /** Sort by name */
    VirtualConnectionTableOrderField["NAME"] = "NAME";
    /** Sort by owner count */
    VirtualConnectionTableOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    /** Sort by vizportalUrlId */
    VirtualConnectionTableOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(VirtualConnectionTableOrderField = exports.VirtualConnectionTableOrderField || (exports.VirtualConnectionTableOrderField = {}));
/** Enum for fields that can be used for sorting */
var WarnableOrderField;
(function (WarnableOrderField) {
    /** Sort by hasActiveWarning */
    WarnableOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    WarnableOrderField["ID"] = "ID";
    /** Sort by luid */
    WarnableOrderField["LUID"] = "LUID";
})(WarnableOrderField = exports.WarnableOrderField || (exports.WarnableOrderField = {}));
/** Enum for fields that can be used for sorting */
var WebDataConnectorOrderField;
(function (WebDataConnectorOrderField) {
    /** Sort by connectionType */
    WebDataConnectorOrderField["CONNECTION_TYPE"] = "CONNECTION_TYPE";
    /** Sort by downstreamDatasources count */
    WebDataConnectorOrderField["DOWNSTREAM_DATASOURCES_COUNT"] = "DOWNSTREAM_DATASOURCES_COUNT";
    /** Sort by downstreamVirtualConnections count */
    WebDataConnectorOrderField["DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT"] = "DOWNSTREAM_VIRTUAL_CONNECTIONS_COUNT";
    /** Sort by downstreamWorkbooks count */
    WebDataConnectorOrderField["DOWNSTREAM_WORKBOOKS_COUNT"] = "DOWNSTREAM_WORKBOOKS_COUNT";
    /** Sort by hasActiveWarning */
    WebDataConnectorOrderField["HAS_ACTIVE_WARNING"] = "HAS_ACTIVE_WARNING";
    /** Sort by id */
    WebDataConnectorOrderField["ID"] = "ID";
    /** Sort by isCertified */
    WebDataConnectorOrderField["IS_CERTIFIED"] = "IS_CERTIFIED";
    /** Sort by isEmbedded */
    WebDataConnectorOrderField["IS_EMBEDDED"] = "IS_EMBEDDED";
    /** Sort by luid */
    WebDataConnectorOrderField["LUID"] = "LUID";
    /** Sort by name */
    WebDataConnectorOrderField["NAME"] = "NAME";
    /** Sort by projectName */
    WebDataConnectorOrderField["PROJECT_NAME"] = "PROJECT_NAME";
})(WebDataConnectorOrderField = exports.WebDataConnectorOrderField || (exports.WebDataConnectorOrderField = {}));
/** Enum for fields that can be used for sorting */
var WorkbookOrderField;
(function (WorkbookOrderField) {
    /** Sort by containerName */
    WorkbookOrderField["CONTAINER_NAME"] = "CONTAINER_NAME";
    /** Sort by containsUnsupportedCustomSql */
    WorkbookOrderField["CONTAINS_UNSUPPORTED_CUSTOM_SQL"] = "CONTAINS_UNSUPPORTED_CUSTOM_SQL";
    /** Sort by dashboards count */
    WorkbookOrderField["DASHBOARDS_COUNT"] = "DASHBOARDS_COUNT";
    /** Sort by embeddedDatasources count */
    WorkbookOrderField["EMBEDDED_DATASOURCES_COUNT"] = "EMBEDDED_DATASOURCES_COUNT";
    /** Sort by id */
    WorkbookOrderField["ID"] = "ID";
    /** Sort by luid */
    WorkbookOrderField["LUID"] = "LUID";
    /** Sort by name */
    WorkbookOrderField["NAME"] = "NAME";
    /** Sort by owner count */
    WorkbookOrderField["OWNER_COUNT"] = "OWNER_COUNT";
    /** Sort by projectLuid */
    WorkbookOrderField["PROJECT_LUID"] = "PROJECT_LUID";
    /** Sort by projectName */
    WorkbookOrderField["PROJECT_NAME"] = "PROJECT_NAME";
    /** Sort by sheets count */
    WorkbookOrderField["SHEETS_COUNT"] = "SHEETS_COUNT";
    /** Sort by views count */
    WorkbookOrderField["VIEWS_COUNT"] = "VIEWS_COUNT";
    /** Sort by vizportalUrlId */
    WorkbookOrderField["VIZPORTAL_URL_ID"] = "VIZPORTAL_URL_ID";
})(WorkbookOrderField = exports.WorkbookOrderField || (exports.WorkbookOrderField = {}));
exports.ColumnFieldsPublishedDatasourceFragmentDoc = (0, client_1.gql) `
    fragment ColumnFieldsPublishedDatasource on PublishedDatasource {
  vizportalUrlId
}
    `;
exports.ColumnFieldsEmbeddedDatasourceFragmentDoc = (0, client_1.gql) `
    fragment ColumnFieldsEmbeddedDatasource on EmbeddedDatasource {
  id
  workbook {
    vizportalUrlId
  }
}
    `;
exports.ColumnFieldsNodesFragmentDoc = (0, client_1.gql) `
    fragment ColumnFieldsNodes on ColumnField {
  id
  name
  datasource {
    name
    ...ColumnFieldsPublishedDatasource
    ...ColumnFieldsEmbeddedDatasource
  }
}
    `;
exports.FlowColumnInputFieldRowDataFragmentDoc = (0, client_1.gql) `
    fragment FlowColumnInputFieldRowData on FlowColumnInputField {
  id
  name
  flow {
    vizportalUrlId
    name
  }
}
    `;
exports.TableauUserFragmentDoc = (0, client_1.gql) `
    fragment TableauUser on TableauUser {
  username
  name
  domain
}
    `;
exports.AssetFragmentDoc = (0, client_1.gql) `
    fragment Asset on CanHaveLabels {
  id
  luid
  name
  __typename
  ... on Column {
    id
    remoteType
    table {
      id
      name
      __typename
    }
  }
  ... on Flow {
    vizportalUrlId
  }
  ... on PublishedDatasource {
    vizportalUrlId
  }
  ... on VirtualConnectionTable {
    vizportalUrlId
  }
  ... on VirtualConnection {
    vizportalUrlId
  }
}
    `;
exports.LabelAssetFragmentDoc = (0, client_1.gql) `
    fragment LabelAsset on Label {
  asset {
    ...Asset
  }
}
    `;
exports.LabelFragmentDoc = (0, client_1.gql) `
    fragment Label on Label {
  id
  authorDisplayName
  author {
    ...TableauUser
  }
  isActive
  value
  isElevated
  message
  category
  updatedAt
  ...LabelAsset
  __typename
}
    `;
exports.UpstreamColumnLabelsFragmentDoc = (0, client_1.gql) `
    fragment UpstreamColumnLabels on Column {
  upstreamColumns @include(if: $customSensitivityLabelsEnabled) {
    luid
    labels(filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}) {
      ...Label
    }
  }
}
    `;
exports.ColumnFragmentDoc = (0, client_1.gql) `
    fragment Column on Column {
  id
  vizportalId
  luid
  name
  description
  remoteType
  labels {
    ...Label
  }
  ...UpstreamColumnLabels
  referencedByFieldsConnection {
    totalCount
  }
  referencedByFlowColumnInputFieldConnection {
    totalCount
  }
  table {
    id
    ... on DatabaseTable {
      luid
    }
  }
}
    `;
exports.ColumnsReferencingFieldColumnsFragmentDoc = (0, client_1.gql) `
    fragment ColumnsReferencingFieldColumns on Column {
  id
  name
  table {
    __typename
    id
    name
  }
}
    `;
exports.DatabaseServerOrPathFragmentDoc = (0, client_1.gql) `
    fragment DatabaseServerOrPath on Database {
  __typename
  name
  ... on DatabaseServer {
    hostName
    port
  }
  ... on CloudFile {
    requestUrl
    fileId
    provider
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
    `;
exports.DataQualityWarningFragmentDoc = (0, client_1.gql) `
    fragment DataQualityWarning on DataQualityWarning {
  id
  __typename
  vizportalId
  isActive
  isSevere
  warningType
  message
  updatedAt
  authorDisplayName
  author {
    ...TableauUser
  }
}
    `;
exports.DataQualityWarningAssetFragmentDoc = (0, client_1.gql) `
    fragment DataQualityWarningAsset on DataQualityWarning {
  asset {
    id
    name
    __typename
    ... on Flow {
      name
      vizportalUrlId
    }
    ... on PublishedDatasource {
      name
      vizportalUrlId
    }
    ... on Database {
      name
    }
    ... on DatabaseTable {
      name
    }
    ... on VirtualConnectionTable {
      name
    }
    ... on VirtualConnection {
      name
    }
    ... on Column {
      name
      remoteType
      table {
        ... on DatabaseTable {
          id
          luid
          name
        }
        ... on VirtualConnectionTable {
          luid
          name
        }
      }
    }
  }
}
    `;
exports.ConnectToDatabasesFragmentDoc = (0, client_1.gql) `
    fragment ConnectToDatabases on Database {
  id
  connectionType
  isCertified
  certificationNote
  contact {
    id
    username
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  ...DatabaseServerOrPath
  dataQualityWarnings {
    ...DataQualityWarning
    ...DataQualityWarningAsset
  }
}
    `;
exports.ConnectToDatabasesConnectionParamsFragmentDoc = (0, client_1.gql) `
    fragment ConnectToDatabasesConnectionParams on Database {
  __typename
  connectionType
  name
  ... on DatabaseServer {
    hostName
    port
    extendedConnectionType
    service
  }
  ... on CloudFile {
    requestUrl
    fileId
    provider
    mimeType
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
    `;
exports.ConnectToTablesConnectionFragmentDoc = (0, client_1.gql) `
    fragment ConnectToTablesConnection on DatabaseTable {
  name
  fullName
  schema
  ... on DatabaseTable {
    database {
      ...ConnectToDatabasesConnectionParams
    }
  }
}
    `;
exports.ConnectToTablesFragmentDoc = (0, client_1.gql) `
    fragment ConnectToTables on DatabaseTable {
  __typename
  contact {
    id
    username
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  id
  isCertified
  certificationNote
  name
  connectionType
  schema
  ... on DatabaseTable {
    database {
      ...DatabaseServerOrPath
      connectionType
    }
    dataQualityWarnings {
      ...DataQualityWarning
      ...DataQualityWarningAsset
    }
  }
}
    `;
exports.CustomSqlDetailsFragmentDoc = (0, client_1.gql) `
    fragment CustomSqlDetails on CustomSQLTable {
  id
  name
  isUnsupportedCustomSql
  query
}
    `;
exports.CustomSqlFromDatasourceFragmentDoc = (0, client_1.gql) `
    fragment CustomSqlFromDatasource on Datasource {
  name
  fields {
    ... on ColumnField {
      columns {
        table {
          ... on CustomSQLTable {
            ...CustomSqlDetails
          }
        }
      }
    }
  }
}
    `;
exports.DashboardsDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment DashboardsDisplayGridRowData on Dashboard {
  id
  name
  path
  workbook {
    vizportalUrlId
    name
    projectName
    projectVizportalUrlId
    owner {
      domain
      username
      name
    }
  }
}
    `;
exports.DataQualityCertificationFragmentDoc = (0, client_1.gql) `
    fragment DataQualityCertification on DataQualityCertification {
  id
  __typename
  vizportalId
  isActive
  message
  updatedAt
  authorDisplayName
  author {
    ...TableauUser
  }
}
    `;
exports.DataQualityCertificationAssetFragmentDoc = (0, client_1.gql) `
    fragment DataQualityCertificationAsset on DataQualityCertification {
  asset {
    id
    name
    __typename
    ... on Flow {
      name
      vizportalUrlId
    }
    ... on PublishedDatasource {
      vizportalUrlId
      name
    }
    ... on Database {
      name
    }
    ... on DatabaseTable {
      name
    }
    ... on VirtualConnectionTable {
      name
    }
    ... on VirtualConnection {
      name
    }
    ... on Column {
      name
      remoteType
      table {
        ... on DatabaseTable {
          id
          luid
          name
        }
        ... on VirtualConnectionTable {
          luid
          name
        }
      }
    }
  }
}
    `;
exports.CertificationsFragmentDoc = (0, client_1.gql) `
    fragment Certifications on Certifiable {
  dataQualityCertifications {
    ...DataQualityCertification
    ...DataQualityCertificationAsset
  }
}
    `;
exports.DatabaseLineageCountsFragmentDoc = (0, client_1.gql) `
    fragment DatabaseLineageCounts on Database {
  unfilteredTablesConnection: tablesConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamVirtualConnectionTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
exports.DatabaseCertificationFragmentDoc = (0, client_1.gql) `
    fragment DatabaseCertification on Database {
  isCertified
  certificationNote
  certifier {
    ...TableauUser
  }
}
    `;
exports.DatabaseFragmentDoc = (0, client_1.gql) `
    fragment Database on Database {
  id
  luid
  vizportalId
  name
  projectName
  projectVizportalUrlId
  description
  isGrouped
  isEmbedded
  ...DatabaseCertification
  contact {
    ...TableauUser
  }
  connectionType
  dataQualityWarnings {
    ...DataQualityWarning
  }
  labels {
    ...Label
  }
  ... on DatabaseServer {
    hostName
    port
  }
  ... on CloudFile {
    fileId
    provider
  }
  ... on File {
    filePath
  }
  ... on WebDataConnector {
    connectorUrl
  }
}
    `;
exports.DatabaseQueryFragmentDoc = (0, client_1.gql) `
    fragment DatabaseQuery on Database {
  ...Database
  tags {
    name
  }
}
    `;
exports.TagsFragmentDoc = (0, client_1.gql) `
    fragment Tags on Taggable {
  tags {
    name
  }
}
    `;
exports.DatabaseIconFragmentDoc = (0, client_1.gql) `
    fragment DatabaseIcon on Database {
  __typename
  connectionType
  isCertified
  certificationNote
}
    `;
exports.DatabasesDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment DatabasesDisplayGridRowData on Database {
  id
  name
  description
  connectionType
  luid
  vizportalId
  isGrouped
  isEmbedded
  ...Tags
  contact {
    ...TableauUser
  }
  controlledPermissionsEnabled: isControlledPermissionsEnabled
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  ...DatabaseIcon
  ...DatabaseServerOrPath
  labels(filter: {isActive: true}) {
    ...Label
  }
}
    `;
exports.DatabasesByIdsNodesFragmentDoc = (0, client_1.gql) `
    fragment DatabasesByIdsNodes on Database {
  id
  name
  controlledPermissionsEnabled: isControlledPermissionsEnabled
}
    `;
exports.NonDatasourceFieldIconFragmentDoc = (0, client_1.gql) `
    fragment NonDatasourceFieldIcon on Field {
  __typename
  ... on DataField {
    dataCategory
    dataType
  }
  ... on AnalyticsField {
    semanticRole
  }
  ... on BinField {
    binField: id
  }
  ... on CalculatedField {
    calculatedField: id
  }
  ... on ColumnField {
    columnField: id
  }
  ... on CombinedField {
    combinedField: id
  }
  ... on CombinedSetField {
    combinedSetField: id
  }
  ... on GroupField {
    groupField: id
    fieldsReferencedByGroup: fields {
      ... on AnalyticsField {
        semanticRole
      }
    }
  }
  ... on HierarchyField {
    hierarchyField: id
  }
  ... on SetField {
    setField: id
  }
}
    `;
exports.FieldIconFragmentDoc = (0, client_1.gql) `
    fragment FieldIcon on Field {
  ...NonDatasourceFieldIcon
  ... on DatasourceField {
    datasourceField: id
    remoteField {
      ...NonDatasourceFieldIcon
    }
  }
}
    `;
exports.FieldDescriptionInheritedFragmentDoc = (0, client_1.gql) `
    fragment FieldDescriptionInherited on Field {
  description
  descriptionInherited {
    assetId
    attribute
    value
    distance
    edges
    asset {
      id
      __typename
      ... on Column {
        name
        table {
          id
          name
        }
      }
      ... on Field {
        name
        datasource {
          id
          name
          __typename
          ... on PublishedDatasource {
            vizportalUrlId
          }
        }
      }
    }
  }
}
    `;
exports.FieldLineageUpstreamLabelsFragmentDoc = (0, client_1.gql) `
    fragment FieldLineageUpstreamLabels on Field {
  __typename
  columnsConnection: upstreamColumnsConnection {
    totalCount
    nodes {
      __typename
      id
      name
      labels(filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}) {
        ...Label
      }
    }
  }
}
    `;
exports.DatasourceFieldsByIdNodesFragmentDoc = (0, client_1.gql) `
    fragment DatasourceFieldsByIdNodes on Field {
  id
  name
  ...FieldIcon
  ...FieldDescriptionInherited
  ...FieldLineageUpstreamLabels
  downstreamSheetsConnection {
    totalCount
  }
}
    `;
exports.DatasourceLineageCountsFragmentDoc = (0, client_1.gql) `
    fragment DatasourceLineageCounts on PublishedDatasource {
  unfilteredFieldsConnection: fieldsConnection(filter: {isHidden: false}) {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
exports.DatasourcesDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment DatasourcesDisplayGridRowData on PublishedDatasource {
  id
  name
  description
  vizportalUrlId
  hasExtracts
  extractLastUpdateTime
  isCertified
  certificationNote
  projectName
  projectVizportalUrlId
  owner {
    username
    name
    domain
  }
  certifier {
    username
    name
    domain
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  containerName
  containerType
}
    `;
exports.NonDatasourceFieldDetails_UpstreamColumnFragmentDoc = (0, client_1.gql) `
    fragment NonDatasourceFieldDetails_UpstreamColumn on Column {
  id
  name
  description
  table {
    id
    name
  }
}
    `;
exports.NonDatasourceFieldDetails_ColumnFragmentDoc = (0, client_1.gql) `
    fragment NonDatasourceFieldDetails_Column on Column {
  id
  name
  description
  table {
    id
    name
  }
  referencedByFlowColumnOutputField {
    parentFields {
      ... on FlowColumnInputField {
        column {
          ...NonDatasourceFieldDetails_UpstreamColumn
        }
      }
    }
  }
  remoteColumn {
    ...NonDatasourceFieldDetails_UpstreamColumn
  }
}
    `;
exports.NonDatasourceFieldDetailsFragmentDoc = (0, client_1.gql) `
    fragment NonDatasourceFieldDetails on Field {
  id
  name
  description
  folderName
  isHidden
  fullyQualifiedName
  ... on DatasourceField {
    datasourceField: id
    remoteField {
      id
      name
      datasource {
        id
        name
        ... on PublishedDatasource {
          vizportalUrlId
        }
      }
      description
    }
  }
  ... on FieldReferencingField {
    fieldsConnection {
      totalCount
    }
  }
  ... on DataField {
    dataCategory
    dataType
    role
  }
  ... on AnalyticsField {
    aggregation
    aggregationParam
    defaultFormat
    semanticRole
  }
  ... on BinField {
    binField: id
    binSize
    formula
    fields {
      id
      name
    }
    parameters {
      name
    }
  }
  ... on CalculatedField {
    calculatedField: id
    formula
    hasUserReference
    isAutoGenerated
    fields {
      id
      name
    }
    parameters {
      name
    }
  }
  ... on ColumnField {
    columnField: id
    columnsConnection {
      totalCount
      nodes {
        ...NonDatasourceFieldDetails_Column
      }
    }
  }
  ... on CombinedField {
    combinedField: id
  }
  ... on CombinedSetField {
    combinedSetField: id
    combinationType
    delimiter
  }
  ... on GroupField {
    groupField: id
    hasOther
    fieldsReferencedByGroup: fields {
      name
      ... on AnalyticsField {
        semanticRole
      }
    }
  }
  ... on HierarchyField {
    hierarchyField: id
  }
  ... on SetField {
    setField: id
  }
}
    `;
exports.FieldDetailsDatasourceFieldFragmentDoc = (0, client_1.gql) `
    fragment FieldDetailsDatasourceField on DatasourceField {
  datasourceField: id
  remoteField {
    datasource {
      name
      ... on PublishedDatasource {
        vizportalUrlId
      }
    }
    ...NonDatasourceFieldDetails
  }
}
    `;
exports.FieldDetailsFragmentDoc = (0, client_1.gql) `
    fragment FieldDetails on Field {
  ... on DatasourceField {
    ...FieldDetailsDatasourceField
  }
  ...NonDatasourceFieldDetails
}
    `;
exports.FieldLineageUpstreamDataQualityWarningsFragmentDoc = (0, client_1.gql) `
    fragment FieldLineageUpstreamDataQualityWarnings on Field {
  __typename
  ... on ColumnField {
    columnsConnection(filter: {hasActiveWarning: true}) {
      totalCount
      nodes {
        __typename
        id
        name
        dataQualityWarnings(filter: {isActive: true}) {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
}
    `;
exports.FieldsReferencedByFieldNodesDatasourceFragmentDoc = (0, client_1.gql) `
    fragment FieldsReferencedByFieldNodesDatasource on Datasource {
  ... on PublishedDatasource {
    name
    vizportalUrlId
  }
  ... on EmbeddedDatasource {
    id
    name
    workbook {
      vizportalUrlId
    }
  }
}
    `;
exports.FieldsReferencedByFieldNodesFragmentDoc = (0, client_1.gql) `
    fragment FieldsReferencedByFieldNodes on Field {
  id
  name
  datasource {
    ...FieldsReferencedByFieldNodesDatasource
  }
}
    `;
exports.FlowFieldDetailsFlowFieldOutputFieldFragmentDoc = (0, client_1.gql) `
    fragment FlowFieldDetailsFlowFieldOutputField on FlowFieldOutputField {
  id
  name
  field {
    id
    name
    downstreamSheetsConnection {
      totalCount
    }
    datasource {
      ... on PublishedDatasource {
        vizportalUrlId
      }
      name
    }
  }
}
    `;
exports.FlowFieldsByIdFlowFieldOutputFieldFragmentDoc = (0, client_1.gql) `
    fragment FlowFieldsByIdFlowFieldOutputField on FlowFieldOutputField {
  name
  id
  field {
    id
    name
    downstreamSheetsConnection {
      totalCount
    }
    ...FieldLineageUpstreamLabels @include(if: $customSensitivityLabelsEnabled)
    ...FieldIcon
  }
}
    `;
exports.FlowFieldsByIdNodesFragmentDoc = (0, client_1.gql) `
    fragment FlowFieldsByIdNodes on FlowOutputField {
  name
  id
  ... on FlowColumnOutputField {
    column {
      id
      name
      labels(filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}) @include(if: $customSensitivityLabelsEnabled) {
        ...Label
      }
      ...UpstreamColumnLabels
      downstreamSheetsConnection {
        totalCount
      }
      remoteType
    }
  }
  ... on FlowFieldOutputField {
    ...FlowFieldsByIdFlowFieldOutputField
  }
}
    `;
exports.FlowLineageCountsFragmentDoc = (0, client_1.gql) `
    fragment FlowLineageCounts on Flow {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
exports.FlowOutputStepsFragmentDoc = (0, client_1.gql) `
    fragment FlowOutputSteps on FlowOutputStep {
  name
  id
  outputFieldsConnection {
    totalCount
  }
}
    `;
exports.FlowDownstreamDatasourcesFragmentDoc = (0, client_1.gql) `
    fragment FlowDownstreamDatasources on PublishedDatasourcesConnection {
  totalCount
}
    `;
exports.FlowDownstreamDatabasesFragmentDoc = (0, client_1.gql) `
    fragment FlowDownstreamDatabases on DatabasesConnection {
  totalCount
}
    `;
exports.FlowsDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment FlowsDisplayGridRowData on Flow {
  id
  name
  vizportalUrlId
  projectVizportalUrlId
  projectName
  owner {
    domain
    username
    name
  }
  containerName
  containerType
}
    `;
exports.FieldLabelsFragmentDoc = (0, client_1.gql) `
    fragment FieldLabels on Field {
  upstreamColumns {
    labels(filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}) {
      ...Label
    }
  }
}
    `;
exports.InheritedLabelsColumnFragmentDoc = (0, client_1.gql) `
    fragment InheritedLabelsColumn on Column {
  id
  name
  luid
  ...UpstreamColumnLabels
  table {
    id
    ... on VirtualConnectionTable {
      vizportalUrlId
    }
  }
}
    `;
exports.InheritedLabelsFieldFragmentDoc = (0, client_1.gql) `
    fragment InheritedLabelsField on Field {
  id
  name
  upstreamColumns {
    luid
  }
}
    `;
exports.InheritedLabelsFlowOutputFieldFragmentDoc = (0, client_1.gql) `
    fragment InheritedLabelsFlowOutputField on FlowOutputField {
  id
  name
  parentFields {
    ... on FlowColumnInputField {
      id
      name
      column {
        luid
      }
    }
  }
}
    `;
exports.LensFieldsByIdFieldsConnectionNodesFragmentDoc = (0, client_1.gql) `
    fragment LensFieldsByIdFieldsConnectionNodes on LensField {
  id
  name
  description
  datasourceField {
    id
    name
    description
    ...FieldIcon
  }
}
    `;
exports.LensLineageCountsFragmentDoc = (0, client_1.gql) `
    fragment LensLineageCounts on Lens {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  fieldsConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
exports.VirtualConnectionsDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment VirtualConnectionsDisplayGridRowData on VirtualConnection {
  __typename
  id
  luid
  vizportalUrlId
  name
  owner {
    name
    username
    domain
  }
  tablesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  isCertified
  labels {
    ...Label
  }
  containerName
  containerType
  projectVizportalUrlId
}
    `;
exports.LensUpstreamVirtualConnectionsNodesFragmentDoc = (0, client_1.gql) `
    fragment LensUpstreamVirtualConnectionsNodes on VirtualConnectionsConnection {
  totalCount
  nodes {
    ...VirtualConnectionsDisplayGridRowData
  }
}
    `;
exports.LensesDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment LensesDisplayGridRowData on Lens {
  id
  name
  description
  vizportalUrlId
  projectVizportalUrlId
  updatedAt
  owner {
    domain
    username
    name
  }
  downstreamWorkbooksConnection {
    totalCount
  }
}
    `;
exports.MetricsDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment MetricsDisplayGridRowData on Metric {
  id
  name
  vizportalUrlId
  projectName
  projectVizportalUrlId
  underlyingView {
    name
    path
    workbook {
      vizportalUrlId
      name
    }
  }
  owner {
    domain
    username
    name
  }
  containerName
  containerType
}
    `;
exports.OwnerIdFragmentDoc = (0, client_1.gql) `
    fragment OwnerId on TableauUser {
  id
  vizportalId
}
    `;
exports.OwnersDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment OwnersDisplayGridRowData on TableauUser {
  id
  name
  username
  domain
  vizportalId
  ownedWorkbooksConnection {
    totalCount
  }
  ownedDatasourcesConnection {
    totalCount
  }
  ownedMetricsConnection {
    totalCount
  }
  ownedVirtualConnectionsConnection {
    totalCount
  }
}
    `;
exports.SheetsDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment SheetsDisplayGridRowData on Sheet {
  id
  name
  path
  workbook {
    vizportalUrlId
    name
    projectName
    projectVizportalUrlId
    owner {
      domain
      username
      name
    }
  }
}
    `;
exports.ColumnLabelsFragmentDoc = (0, client_1.gql) `
    fragment ColumnLabels on Column {
  luid
  labels(filter: {isActive: true}) {
    ...Label
  }
}
    `;
exports.ColumnsByTableIdFragmentDoc = (0, client_1.gql) `
    fragment ColumnsByTableId on Column {
  id
  luid
  name
  remoteType
  description
  ...ColumnLabels
  ...UpstreamColumnLabels
  downstreamSheetsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
}
    `;
exports.TableColumnsByIdColumnsFragmentDoc = (0, client_1.gql) `
    fragment TableColumnsByIdColumns on Column {
  ...Tags
  ...ColumnsByTableId
}
    `;
exports.TableLineageCountsFragmentDoc = (0, client_1.gql) `
    fragment TableLineageCounts on Table {
  __typename
  name
  unfilteredColumnsConnection: columnsConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  downstreamDatabasesConnection {
    totalCount
  }
  downstreamTablesConnection {
    totalCount
  }
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamVirtualConnectionTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
exports.TableCertificationFragmentDoc = (0, client_1.gql) `
    fragment TableCertification on DatabaseTable {
  isCertified
  certificationNote
  certifier {
    ...TableauUser
  }
}
    `;
exports.TableFragmentDoc = (0, client_1.gql) `
    fragment Table on Table {
  id
  name
  description
  isEmbedded
  ... on DatabaseTable {
    fullName
    luid
    vizportalId
    description
    ...TableCertification
    contact {
      ...TableauUser
    }
    dataQualityWarnings {
      ...DataQualityWarning
    }
    labels {
      ...Label
    }
    database {
      id
      name
      connectionType
      isCertified
      ... on DatabaseServer {
        hostName
        port
      }
      ... on CloudFile {
        fileId
        provider
      }
      ... on File {
        filePath
      }
      ... on WebDataConnector {
        connectorUrl
      }
    }
  }
}
    `;
exports.TableQueryFragmentDoc = (0, client_1.gql) `
    fragment TableQuery on Table {
  ...Table
  ... on DatabaseTable {
    tags {
      name
    }
  }
}
    `;
exports.TagsQueryWithFiltersTagsConnectionNodesFragmentDoc = (0, client_1.gql) `
    fragment TagsQueryWithFiltersTagsConnectionNodes on Tag {
  id
  name
  databasesConnection(
    filter: {connectionType: $connectionTypeFilter, isCertified: $isCertifiedFilter, isEmbedded: $isEmbeddedFilter, hasActiveWarning: $hasActiveWarningFilter, text: $textSearch}
  ) {
    totalCount
  }
  databaseTablesConnection(
    filter: {connectionType: $connectionTypeFilter, isCertified: $isCertifiedFilter, isEmbedded: $isEmbeddedFilter, hasActiveWarning: $hasActiveWarningFilter, text: $textSearch}
  ) {
    totalCount
  }
}
    `;
exports.TagsQueryWithFiltersTagsConnectionFragmentDoc = (0, client_1.gql) `
    fragment TagsQueryWithFiltersTagsConnection on TagsConnection {
  totalCount
  nodes {
    ...TagsQueryWithFiltersTagsConnectionNodes
  }
}
    `;
exports.SheetFieldInstanceDatasourceFragmentDoc = (0, client_1.gql) `
    fragment SheetFieldInstanceDatasource on Datasource {
  __typename
  id
  name
  hasExtracts
  extractLastUpdateTime
  ... on PublishedDatasource {
    vizportalUrlId
    isCertified
  }
}
    `;
exports.SheetFieldInstancePublishedDatasourceFragmentDoc = (0, client_1.gql) `
    fragment SheetFieldInstancePublishedDatasource on PublishedDatasource {
  __typename
  id
  luid
  name
  hasExtracts
  extractLastUpdateTime
  vizportalUrlId
  isCertified
}
    `;
exports.DatasourceFieldDetails_RemoteColumnFragmentDoc = (0, client_1.gql) `
    fragment DatasourceFieldDetails_RemoteColumn on Column {
  id
  name
  description
  table {
    id
    name
  }
}
    `;
exports.SheetFieldInstanceDatasourceFieldFragmentDoc = (0, client_1.gql) `
    fragment SheetFieldInstanceDatasourceField on DatasourceField {
  datasourceField: id
  remoteField {
    publishedDataSourceDetails: datasource {
      ...SheetFieldInstancePublishedDatasource
    }
    datasource {
      ...SheetFieldInstanceDatasource
    }
    ...NonDatasourceFieldDetails
    referencedByFlowFieldOutputField {
      parentFields {
        ... on FlowColumnInputField {
          column {
            id
            name
            description
            table {
              id
              name
            }
            remoteColumn {
              ...DatasourceFieldDetails_RemoteColumn
            }
          }
        }
      }
    }
  }
}
    `;
exports.SheetFieldInstanceUpstreamDatabasesConnectionFragmentDoc = (0, client_1.gql) `
    fragment SheetFieldInstanceUpstreamDatabasesConnection on DatabasesConnection {
  nodes {
    id
    name
    connectionType
    isCertified
  }
}
    `;
exports.SheetFieldInstanceFragmentDoc = (0, client_1.gql) `
    fragment SheetFieldInstance on Field {
  __typename
  id
  name
  description
  datasource {
    ...SheetFieldInstanceDatasource
    ...SheetFieldInstancePublishedDatasource
  }
  ... on DatasourceField {
    ...SheetFieldInstanceDatasourceField
  }
  ...NonDatasourceFieldDetails
  upstreamDatabasesConnection {
    ...SheetFieldInstanceUpstreamDatabasesConnection
  }
}
    `;
exports.ViewDetailsByPathDashboardFragmentDoc = (0, client_1.gql) `
    fragment ViewDetailsByPathDashboard on Dashboard {
  sheets {
    worksheetFields {
      id
    }
    datasourceFields {
      id
    }
  }
  upstreamSheetFieldInstances(orderBy: {field: NAME, direction: ASC}) {
    ...SheetFieldInstance
  }
}
    `;
exports.ViewDetailsByPathSheetFragmentDoc = (0, client_1.gql) `
    fragment ViewDetailsByPathSheet on Sheet {
  worksheetFields {
    id
  }
  datasourceFields {
    id
  }
  sheetFieldInstances(orderBy: {field: NAME, direction: ASC}) {
    ...SheetFieldInstance
  }
}
    `;
exports.ViewDetailsByPathFragmentDoc = (0, client_1.gql) `
    fragment ViewDetailsByPath on View {
  __typename
  id
  name
  updatedAt
  path
  workbook {
    owner {
      id
      name
      username
      uri
      domain
    }
    name
    projectName
    projectVizportalUrlId
    vizportalUrlId
  }
  ... on Dashboard {
    ...ViewDetailsByPathDashboard
  }
  ... on Sheet {
    ...ViewDetailsByPathSheet
  }
}
    `;
exports.VirtualConnectionLineageCountsFragmentDoc = (0, client_1.gql) `
    fragment VirtualConnectionLineageCounts on VirtualConnection {
  unfilteredTablesConnection: tablesConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  downstreamVirtualConnectionTablesConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
exports.VirtualConnectionTablesFragmentDoc = (0, client_1.gql) `
    fragment VirtualConnectionTables on VirtualConnectionTable {
  name
  id
}
    `;
exports.VirtualConnectionTableLineageCountsFragmentDoc = (0, client_1.gql) `
    fragment VirtualConnectionTableLineageCounts on VirtualConnectionTable {
  unfilteredColumnsConnection: columnsConnection {
    totalCount
  }
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamFlowsConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  downstreamLensesConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDashboardsConnection {
    totalCount
  }
  downstreamSheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
exports.TableDatabaseNameFragmentDoc = (0, client_1.gql) `
    fragment TableDatabaseName on Table {
  __typename
  ... on DatabaseTable {
    vizportalId
    database {
      name
      isGrouped
      ... on DatabaseServer {
        hostName
      }
      ... on File {
        filePath
      }
    }
  }
}
    `;
exports.TablesDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment TablesDisplayGridRowData on Table {
  __typename
  id
  name
  description
  isEmbedded
  downstreamVirtualConnectionsConnection {
    totalCount
  }
  downstreamWorkbooksConnection {
    totalCount
  }
  downstreamDatasourcesConnection {
    totalCount
  }
  ... on DatabaseTable {
    luid
    contact {
      ...TableauUser
    }
    projectName
    projectVizportalUrlId
    ...TableCertification
    labels(filter: {isActive: true}) {
      ...Label
    }
  }
  ... on VirtualConnectionTable {
    luid
    vizportalUrlId
    isCertified
    labels(filter: {isActive: true}) {
      ...Label
    }
    isExtracted
    extractLastRefreshedAt
  }
  ...TableDatabaseName
  columnsConnectionWithWarnings: columnsConnection(
    filter: {hasActiveWarning: true}
  ) {
    totalCount
    nodes {
      labels(filter: {isActive: true}) {
        ...Label
        __typename
      }
    }
  }
  columnsConnection(first: 3, orderBy: {field: NAME, direction: ASC}) {
    totalCount
    nodes {
      name
    }
  }
}
    `;
exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment VirtualConnectionTablesDisplayGridRowData on VirtualConnectionTable {
  ...TablesDisplayGridRowData
}
    `;
exports.WorkbookFieldsByIdFieldsConnectionFragmentDoc = (0, client_1.gql) `
    fragment WorkbookFieldsByIdFieldsConnection on Field {
  id
  name
  ...FieldIcon
  ...FieldDescriptionInherited
  ...FieldLineageUpstreamLabels
  downstreamSheetsConnection {
    totalCount
  }
}
    `;
exports.WorkbookLineageCountsFragmentDoc = (0, client_1.gql) `
    fragment WorkbookLineageCounts on Workbook {
  upstreamDatabasesConnection {
    totalCount
  }
  upstreamTablesConnection {
    totalCount
  }
  upstreamVirtualConnectionsConnection {
    totalCount
  }
  upstreamVirtualConnectionTablesConnection {
    totalCount
  }
  upstreamFlowsConnection {
    totalCount
  }
  upstreamDatasourcesConnection {
    totalCount
  }
  upstreamLensesConnection {
    totalCount
  }
  dashboardsConnection {
    totalCount
  }
  sheetsConnection {
    totalCount
  }
  downstreamMetricsConnection {
    totalCount
  }
  downstreamOwnersConnection {
    totalCount
  }
}
    `;
exports.WorkbookEmbeddedDatasourceFragmentDoc = (0, client_1.gql) `
    fragment WorkbookEmbeddedDatasource on EmbeddedDatasource {
  name
  id
  fieldsConnection(filter: {isHidden: false}) {
    totalCount
  }
}
    `;
exports.WorkbooksDisplayGridRowDataFragmentDoc = (0, client_1.gql) `
    fragment WorkbooksDisplayGridRowData on Workbook {
  id
  name
  vizportalUrlId
  projectName
  projectVizportalUrlId
  owner {
    name
    username
    domain
  }
  sheetsConnection {
    totalCount
  }
  containerName
  containerType
}
    `;
exports.CatalogSelectorDropdownCountsDocument = (0, client_1.gql) `
    query CatalogSelectorDropdownCounts($textSearch: String, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  databaseTablesConnection(
    filter: {text: $textSearch, hasActiveWarning: $hasActiveWarning, isCertified: $isCertified}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
  }
  databasesConnection(
    filter: {text: $textSearch, hasActiveWarning: $hasActiveWarning, isCertified: $isCertified}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
  }
}
    `;
exports.ColumnDetailsDocument = (0, client_1.gql) `
    query ColumnDetails($columnId: ID!, $customSensitivityLabelsEnabled: Boolean!) {
  columns(filter: {id: $columnId}) {
    ...Column
    ...Tags
  }
}
    ${exports.ColumnFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.UpstreamColumnLabelsFragmentDoc}
${exports.TagsFragmentDoc}`;
exports.ColumnDetailsByLuidDocument = (0, client_1.gql) `
    query ColumnDetailsByLuid($columnId: ID!) {
  columns(filter: {id: $columnId}) {
    remoteType
    luid
    name
  }
}
    `;
exports.ColumnFieldsDocument = (0, client_1.gql) `
    query ColumnFields($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: {id: $columnId}) {
    referencedByFieldsConnection(
      first: $first
      offset: $offset
      orderBy: {field: NAME, direction: ASC}
    ) {
      totalCount
      nodes {
        ...ColumnFieldsNodes
      }
    }
  }
}
    ${exports.ColumnFieldsNodesFragmentDoc}
${exports.ColumnFieldsPublishedDatasourceFragmentDoc}
${exports.ColumnFieldsEmbeddedDatasourceFragmentDoc}`;
exports.ColumnFlowsDocument = (0, client_1.gql) `
    query ColumnFlows($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: {id: $columnId}) {
    referencedByFlowColumnInputFieldConnection(
      first: $first
      offset: $offset
      orderBy: {field: NAME, direction: ASC}
    ) {
      totalCount
      nodes {
        ...FlowColumnInputFieldRowData
      }
    }
  }
}
    ${exports.FlowColumnInputFieldRowDataFragmentDoc}`;
exports.ColumnsReferencingFieldDocument = (0, client_1.gql) `
    query ColumnsReferencingField($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: {id: $fieldId}) {
    __typename
    ... on ColumnField {
      columnsConnection(
        first: $first
        offset: $offset
        orderBy: {field: ID, direction: ASC}
      ) {
        totalCount
        nodes {
          ...ColumnsReferencingFieldColumns
        }
      }
    }
  }
}
    ${exports.ColumnsReferencingFieldColumnsFragmentDoc}`;
exports.ConnectToDatabasesConnectionParamsDocument = (0, client_1.gql) `
    query ConnectToDatabasesConnectionParams($databaseId: ID!) {
  databasesConnection(filter: {id: $databaseId}, permissionMode: FILTER_RESULTS) {
    nodes {
      ...ConnectToDatabasesConnectionParams
    }
  }
}
    ${exports.ConnectToDatabasesConnectionParamsFragmentDoc}`;
exports.ConnectToDatabasesDescriptionDocument = (0, client_1.gql) `
    query ConnectToDatabasesDescription($databaseId: ID!) {
  databasesConnection(filter: {id: $databaseId}, permissionMode: FILTER_RESULTS) {
    nodes {
      description
      connectionType
    }
  }
}
    `;
exports.ConnectToDatabasesDocument = (0, client_1.gql) `
    query ConnectToDatabases($databaseFilterText: String, $first: Int, $offset: Int, $connectionTypeFilterText: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean, $orderBy: DatabaseSortOrder!, $columnDQWs: Boolean!) {
  databasesConnection(
    filter: {text: $databaseFilterText, connectionType: $connectionTypeFilterText, isCertified: $isCertifiedFilter, isEmbedded: false, hasActiveWarning: $hasActiveWarningFilter}
    first: $first
    offset: $offset
    orderBy: $orderBy
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...ConnectToDatabases
    }
  }
  maxDownstreamWorkbooks: databasesConnection(
    filter: {text: $databaseFilterText, connectionType: $connectionTypeFilterText, isCertified: $isCertifiedFilter, isEmbedded: false, hasActiveWarning: $hasActiveWarningFilter}
    first: 1
    orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection {
        totalCount
      }
    }
  }
}
    ${exports.ConnectToDatabasesFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.DataQualityWarningFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DataQualityWarningAssetFragmentDoc}`;
exports.ConnectToDatabasesTotalCountDocument = (0, client_1.gql) `
    query ConnectToDatabasesTotalCount($connectionTypeFilterText: String, $databaseFilterText: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean) {
  databasesConnection(
    filter: {text: $databaseFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter, isEmbedded: false}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
  }
}
    `;
exports.ConnectToTablesConnectionParamsDocument = (0, client_1.gql) `
    query ConnectToTablesConnectionParams($tableId: ID!) {
  databaseTablesConnection(filter: {id: $tableId}, permissionMode: FILTER_RESULTS) {
    nodes {
      ...ConnectToTablesConnection
    }
  }
}
    ${exports.ConnectToTablesConnectionFragmentDoc}
${exports.ConnectToDatabasesConnectionParamsFragmentDoc}`;
exports.ConnectToTablesDescriptionDocument = (0, client_1.gql) `
    query ConnectToTablesDescription($tableId: ID!) {
  databaseTablesConnection(filter: {id: $tableId}, permissionMode: FILTER_RESULTS) {
    nodes {
      description
      ... on DatabaseTable {
        database {
          connectionType
        }
      }
    }
  }
}
    `;
exports.ConnectToTablesDocument = (0, client_1.gql) `
    query ConnectToTables($first: Int!, $offset: Int!, $tableFilterText: String!, $connectionTypeFilterText: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean, $orderBy: DatabaseTableSortOrder!, $columnDQWs: Boolean!) {
  databaseTablesConnection(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: {text: $tableFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter, isEmbedded: false}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...ConnectToTables
    }
  }
  maxDownstreamDatasources: databaseTablesConnection(
    first: 1
    orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
    filter: {text: $tableFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter, isEmbedded: false}
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamDatasourcesConnection {
        totalCount
      }
    }
  }
  maxDownstreamWorkbooks: databaseTablesConnection(
    first: 1
    orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
    filter: {text: $tableFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter, isEmbedded: false}
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection {
        totalCount
      }
    }
  }
}
    ${exports.ConnectToTablesFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.DataQualityWarningFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DataQualityWarningAssetFragmentDoc}`;
exports.ConnectToTablesTotalCountDocument = (0, client_1.gql) `
    query ConnectToTablesTotalCount($tableFilterText: String, $connectionTypeFilterText: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean) {
  databaseTablesConnection(
    filter: {text: $tableFilterText, connectionType: $connectionTypeFilterText, hasActiveWarning: $hasActiveWarningFilter, isCertified: $isCertifiedFilter}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
  }
}
    `;
exports.WorkbookCustomSqlDocument = (0, client_1.gql) `
    query WorkbookCustomSql($vizportalUrlId: String!, $selectedEmbeddedDatasourceId: ID!) {
  workbooks(filter: {vizportalUrlId: $vizportalUrlId}) {
    embeddedDatasources(filter: {id: $selectedEmbeddedDatasourceId}) {
      name
      ...CustomSqlFromDatasource
    }
  }
}
    ${exports.CustomSqlFromDatasourceFragmentDoc}
${exports.CustomSqlDetailsFragmentDoc}`;
exports.PublishedDatasourceCustomSqlDocument = (0, client_1.gql) `
    query PublishedDatasourceCustomSql($vizportalUrlId: String!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...CustomSqlFromDatasource
  }
}
    ${exports.CustomSqlFromDatasourceFragmentDoc}
${exports.CustomSqlDetailsFragmentDoc}`;
exports.VirtualConnectionCustomSqlDocument = (0, client_1.gql) `
    query VirtualConnectionCustomSql($vizportalUrlId: String!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tables {
      columns {
        remoteColumn {
          table {
            ... on CustomSQLTable {
              ...CustomSqlDetails
            }
          }
        }
      }
    }
  }
}
    ${exports.CustomSqlDetailsFragmentDoc}`;
exports.FlowCustomSqlDocument = (0, client_1.gql) `
    query FlowCustomSql($vizportalUrlId: String!, $selectedOutputStepId: ID!) {
  flows(filter: {vizportalUrlId: $vizportalUrlId}) {
    outputSteps(filter: {id: $selectedOutputStepId}) {
      name
      outputFields {
        parentFields {
          ... on FlowColumnInputField {
            column {
              table {
                ... on CustomSQLTable {
                  ...CustomSqlDetails
                }
              }
            }
          }
        }
      }
    }
  }
}
    ${exports.CustomSqlDetailsFragmentDoc}`;
exports.ViewWarningsDocument = (0, client_1.gql) `
    query ViewWarnings($viewPath: String!) {
  views(filter: {path: $viewPath}, permissionMode: FILTER_RESULTS) {
    normalUpstreamDataQualityWarnings: upstreamDataQualityWarnings(
      filter: {isActive: true, isSevere: false}
    ) {
      id
    }
    severeUpstreamDataQualityWarnings: upstreamDataQualityWarnings(
      filter: {isActive: true, isSevere: true}
    ) {
      id
    }
  }
}
    `;
exports.DataQualityWarningsInWebAuthoringDocument = (0, client_1.gql) `
    query DataQualityWarningsInWebAuthoring($workbookIds: [String!]!, $flowIds: [String!]!, $publishedDatasourceIds: [String!]!, $databaseServerIds: [String!]!, $databaseTableIds: [String!]!) {
  publishedDatasourcesConnection(filter: {luidWithin: $publishedDatasourceIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
  workbooksConnection(filter: {luidWithin: $workbookIds}) {
    nodes {
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
  flowsConnection(filter: {luidWithin: $flowIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
  databaseServersConnection(filter: {luidWithin: $databaseServerIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
  databaseTablesConnection(filter: {luidWithin: $databaseTableIds}) {
    nodes {
      dataQualityWarnings(filter: {isActive: true}) {
        ...DataQualityWarning
        ...DataQualityWarningAsset
      }
      upstreamDataQualityWarningsConnection(filter: {isActive: true}) {
        nodes {
          ...DataQualityWarning
          ...DataQualityWarningAsset
        }
      }
    }
  }
}
    ${exports.DataQualityWarningFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DataQualityWarningAssetFragmentDoc}`;
exports.DatabaseDownstreamDashboardsFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamDashboardsFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamDashboardsConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...DashboardsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamDashboardsDocument = (0, client_1.gql) `
    query DatabaseDownstreamDashboards($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamDatabasesFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamDatabasesFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseDownstreamDatabasesDocument = (0, client_1.gql) `
    query DatabaseDownstreamDatabases($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseDownstreamDatasourcesFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamDatasourcesFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamDatasourcesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamDatasourcesDocument = (0, client_1.gql) `
    query DatabaseDownstreamDatasources($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamFlowsFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamFlowsFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamFlowsDocument = (0, client_1.gql) `
    query DatabaseDownstreamFlows($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamLensesFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamLensesFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...LensesDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamLensesDocument = (0, client_1.gql) `
    query DatabaseDownstreamLenses($id: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  databases(filter: {id: $id}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamMetricsFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamMetricsFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...MetricsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamMetricsDocument = (0, client_1.gql) `
    query DatabaseDownstreamMetrics($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamOwnerIdsFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamOwnerIdsFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamOwnersConnection(first: $first, offset: $offset) {
        totalCount
        nodes {
          ...OwnerId
        }
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.DatabaseDownstreamOwnerIdsDocument = (0, client_1.gql) `
    query DatabaseDownstreamOwnerIds($databaseId: ID!, $first: Int!, $offset: Int!) {
  databases(filter: {id: $databaseId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.DatabaseDownstreamOwnersFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamOwnersFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tablesConnection(filter: {id: $tableId}) {
      nodes {
        downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...OwnersDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamOwnersDocument = (0, client_1.gql) `
    query DatabaseDownstreamOwners($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamSheetsFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamSheetsFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...SheetsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamSheetsDocument = (0, client_1.gql) `
    query DatabaseDownstreamSheets($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamTablesFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamTablesFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatabaseDownstreamTablesDocument = (0, client_1.gql) `
    query DatabaseDownstreamTables($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatabaseDownstreamVirtualConnectionTablesFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamVirtualConnectionTablesFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamVirtualConnectionTablesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...VirtualConnectionTablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamVirtualConnectionTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamVirtualConnectionTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatabaseDownstreamVirtualConnectionTablesDocument = (0, client_1.gql) `
    query DatabaseDownstreamVirtualConnectionTables($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatabaseDownstreamVirtualConnectionsFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamVirtualConnectionsFilteredByTable($databseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  databases(filter: {id: $databseId}) {
    tables(filter: {id: $tableId}) {
      downstreamVirtualConnectionsConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...VirtualConnectionsDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamVirtualConnectionsConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamVirtualConnectionsConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseDownstreamVirtualConnectionsDocument = (0, client_1.gql) `
    query DatabaseDownstreamVirtualConnections($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseDownstreamWorkbooksFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseDownstreamWorkbooksFilteredByTable($databaseId: ID!, $tableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tables(filter: {id: $tableId}) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...WorkbooksDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.DatabaseDownstreamWorkbooksDocument = (0, client_1.gql) `
    query DatabaseDownstreamWorkbooks($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  databases(filter: {id: $databaseId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.DatabaseLineageCountsFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseLineageCountsFilteredByTable($databaseId: ID!, $tableId: ID!) {
  databases(filter: {id: $databaseId}) {
    ...DatabaseLineageCounts
    filteredTablesConnection: tablesConnection(filter: {id: $tableId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamVirtualConnectionsConnection {
          totalCount
        }
        downstreamVirtualConnectionTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabaseLineageCountsFragmentDoc}`;
exports.DatabaseLineageCountsDocument = (0, client_1.gql) `
    query DatabaseLineageCounts($databaseId: ID!) {
  databases(filter: {id: $databaseId}) {
    ...DatabaseLineageCounts
  }
}
    ${exports.DatabaseLineageCountsFragmentDoc}`;
exports.DatabaseDocument = (0, client_1.gql) `
    query Database($databaseId: ID!) {
  databases(filter: {id: $databaseId}, permissionMode: FILTER_RESULTS) {
    ...DatabaseQuery
  }
}
    ${exports.DatabaseQueryFragmentDoc}
${exports.DatabaseFragmentDoc}
${exports.DatabaseCertificationFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DataQualityWarningFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseQueryWithCertificationsDocument = (0, client_1.gql) `
    query DatabaseQueryWithCertifications($databaseId: ID!) {
  databases(filter: {id: $databaseId}, permissionMode: FILTER_RESULTS) {
    ...Database
    ...Tags
    ...Certifications
  }
}
    ${exports.DatabaseFragmentDoc}
${exports.DatabaseCertificationFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DataQualityWarningFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TagsFragmentDoc}
${exports.CertificationsFragmentDoc}
${exports.DataQualityCertificationFragmentDoc}
${exports.DataQualityCertificationAssetFragmentDoc}`;
exports.DatabaseTableDocument = (0, client_1.gql) `
    query DatabaseTable($tableId: ID!) {
  databaseTables(filter: {id: $tableId}, permissionMode: FILTER_RESULTS) {
    luid
    vizportalId
    ...Table
    ...Tags
    ...Certifications
  }
}
    ${exports.TableFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DataQualityWarningFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TagsFragmentDoc}
${exports.CertificationsFragmentDoc}
${exports.DataQualityCertificationFragmentDoc}
${exports.DataQualityCertificationAssetFragmentDoc}`;
exports.DatabaseTablesByIdDocument = (0, client_1.gql) `
    query DatabaseTablesById($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    tablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: tablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: tablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatabaseUpstreamDatabasesFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseUpstreamDatabasesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseUpstreamDatabasesDocument = (0, client_1.gql) `
    query DatabaseUpstreamDatabases($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseUpstreamDatasourcesFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseUpstreamDatasourcesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.DatabaseUpstreamDatasourcesDocument = (0, client_1.gql) `
    query DatabaseUpstreamDatasources($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.DatabaseUpstreamFlowsFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseUpstreamFlowsFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseUpstreamFlowsDocument = (0, client_1.gql) `
    query DatabaseUpstreamFlows($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.DatabaseUpstreamTablesFilteredByTableDocument = (0, client_1.gql) `
    query DatabaseUpstreamTablesFilteredByTable($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatabaseUpstreamTablesDocument = (0, client_1.gql) `
    query DatabaseUpstreamTables($databaseId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  databases(filter: {id: $databaseId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatabasesByTagDocument = (0, client_1.gql) `
    query DatabasesByTag($tagName: String!, $first: Int!, $offset: Int!, $textSearch: String, $orderBy: DatabaseSortOrder!, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  tags(filter: {name: $tagName}) {
    databasesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      permissionMode: FILTER_RESULTS
    ) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: databasesConnection(
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: databasesConnection(
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabasesByIdsDocument = (0, client_1.gql) `
    query DatabasesByIds($first: Int!, $offset: Int!, $databaseIds: [ID]!) {
  databasesConnection(
    first: $first
    offset: $offset
    filter: {idWithin: $databaseIds}
  ) {
    totalCount
    nodes {
      ...DatabasesByIdsNodes
    }
  }
}
    ${exports.DatabasesByIdsNodesFragmentDoc}`;
exports.DatabasesDocument = (0, client_1.gql) `
    query Databases($first: Int!, $offset: Int!, $textSearch: String, $orderBy: DatabaseSortOrder!, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  databasesConnection(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...DatabasesDisplayGridRowData
    }
  }
  maxDownstreamDatasources: databasesConnection(
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
    first: 1
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamDatasourcesConnection {
        totalCount
      }
    }
  }
  maxDownstreamWorkbooks: databasesConnection(
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
    first: 1
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection {
        totalCount
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatasourceDownstreamDashboardsDocument = (0, client_1.gql) `
    query DatasourceDownstreamDashboards($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.DatasourceDownstreamDatabasesDocument = (0, client_1.gql) `
    query DatasourceDownstreamDatabases($vizportalUrlId: String, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatasourceDownstreamDatasourcesDocument = (0, client_1.gql) `
    query DatasourceDownstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.DatasourceDownstreamFlowsDocument = (0, client_1.gql) `
    query DatasourceDownstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.DatasourceDownstreamLensesFilteredByFieldDocument = (0, client_1.gql) `
    query DatasourceDownstreamLensesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...LensesDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.DatasourceDownstreamLensesDocument = (0, client_1.gql) `
    query DatasourceDownstreamLenses($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.DatasourceDownstreamMetricsDocument = (0, client_1.gql) `
    query DatasourceDownstreamMetrics($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.DatasourceDownstreamOwnerIdsDocument = (0, client_1.gql) `
    query DatasourceDownstreamOwnerIds($datasourceVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  publishedDatasources(filter: {vizportalUrlId: $datasourceVizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.DatasourceDownstreamOwnersDocument = (0, client_1.gql) `
    query DatasourceDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.DatasourceDownstreamSheetsDocument = (0, client_1.gql) `
    query DatasourceDownstreamSheets($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.DatasourceDownstreamTablesDocument = (0, client_1.gql) `
    query DatasourceDownstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatasourceDownstreamWorkbooksFilteredByFieldDocument = (0, client_1.gql) `
    query DatasourceDownstreamWorkbooksFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          id
          name
          vizportalUrlId
          description
          projectName
          containerName
          containerType
          projectVizportalUrlId
          owner {
            name
            username
            domain
          }
          sheetsConnection {
            totalCount
          }
        }
      }
    }
  }
}
    `;
exports.DatasourceDownstreamWorkbooksDocument = (0, client_1.gql) `
    query DatasourceDownstreamWorkbooks($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.DatasourceFieldsByIdDocument = (0, client_1.gql) `
    query DatasourceFieldsById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FieldSortOrder!, $searchText: String) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    fieldsConnection(
      filter: {isHidden: false, text: $searchText}
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourceFieldsByIdNodes
      }
    }
  }
}
    ${exports.DatasourceFieldsByIdNodesFragmentDoc}
${exports.FieldIconFragmentDoc}
${exports.NonDatasourceFieldIconFragmentDoc}
${exports.FieldDescriptionInheritedFragmentDoc}
${exports.FieldLineageUpstreamLabelsFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatasourceFieldsWithInheritanceByIdDocument = (0, client_1.gql) `
    query DatasourceFieldsWithInheritanceById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FieldSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    fieldsConnection(
      filter: {isHidden: false}
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        id
        name
        ...FieldDescriptionInherited
        downstreamSheetsConnection {
          totalCount
        }
        ...FieldIcon
      }
    }
  }
}
    ${exports.FieldDescriptionInheritedFragmentDoc}
${exports.FieldIconFragmentDoc}
${exports.NonDatasourceFieldIconFragmentDoc}`;
exports.DatasourceLineageCountsFilteredByFieldDocument = (0, client_1.gql) `
    query DatasourceLineageCountsFilteredByField($vizportalUrlId: String!, $selectedFieldId: ID!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...DatasourceLineageCounts
    filteredFieldsConnection: fieldsConnection(filter: {id: $selectedFieldId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamVirtualConnectionsConnection {
          totalCount
        }
        upstreamVirtualConnectionTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatasourceLineageCountsFragmentDoc}`;
exports.DatasourceLineageCountsDocument = (0, client_1.gql) `
    query DatasourceLineageCounts($vizportalUrlId: String!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...DatasourceLineageCounts
  }
}
    ${exports.DatasourceLineageCountsFragmentDoc}`;
exports.DatasourceDocument = (0, client_1.gql) `
    query Datasource($vizportalUrlId: String!) {
  publishedDatasources(
    filter: {vizportalUrlId: $vizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
  }
}
    `;
exports.DatasourceUpstreamDatabasesDocument = (0, client_1.gql) `
    query DatasourceUpstreamDatabases($vizportalUrlId: String, $first: Int, $offset: Int, $orderBy: DatabaseSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatasourceUpstreamDatasourcesDocument = (0, client_1.gql) `
    query DatasourceUpstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.DatasourceUpstreamFlowsDocument = (0, client_1.gql) `
    query DatasourceUpstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.DatasourceUpstreamTablesDocument = (0, client_1.gql) `
    query DatasourceUpstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatasourceUpstreamVirtualConnectionTablesDocument = (0, client_1.gql) `
    query DatasourceUpstreamVirtualConnectionTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DatasourceUpstreamVirtualConnectionsDocument = (0, client_1.gql) `
    query DatasourceUpstreamVirtualConnections($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  publishedDatasources(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DownstreamDashboardsFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamDashboardsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDashboardsConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...DashboardsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.DownstreamDatabasesFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamDatabasesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DownstreamDatasourcesFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamDatasourcesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamDatasourcesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.DownstreamFlowsFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamFlowsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.DownstreamMetricsFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamMetricsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...MetricsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.DownstreamOwnerIdsFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamOwnerIdsFilteredByField($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: {id: $fieldId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.DownstreamOwnersFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamOwnersFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...OwnersDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.DownstreamSheetsFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamSheetsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...SheetsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.DownstreamTablesFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamTablesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.DownstreamWorkbooksFilteredByFieldDocument = (0, client_1.gql) `
    query DownstreamWorkbooksFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...WorkbooksDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.FieldDetailsDocument = (0, client_1.gql) `
    query FieldDetails($fieldId: ID!) {
  fields(filter: {id: $fieldId}) {
    ...FieldDetails
  }
}
    ${exports.FieldDetailsFragmentDoc}
${exports.FieldDetailsDatasourceFieldFragmentDoc}
${exports.NonDatasourceFieldDetailsFragmentDoc}
${exports.NonDatasourceFieldDetails_ColumnFragmentDoc}
${exports.NonDatasourceFieldDetails_UpstreamColumnFragmentDoc}`;
exports.FieldsReferencedByFieldDocument = (0, client_1.gql) `
    query FieldsReferencedByField($fieldId: ID!, $first: Int!, $offset: Int!) {
  fields(filter: {id: $fieldId}) {
    ... on FieldReferencingField {
      fieldsConnection(
        first: $first
        offset: $offset
        orderBy: {field: ID, direction: ASC}
      ) {
        totalCount
        nodes {
          ...FieldsReferencedByFieldNodes
        }
      }
    }
  }
}
    ${exports.FieldsReferencedByFieldNodesFragmentDoc}
${exports.FieldsReferencedByFieldNodesDatasourceFragmentDoc}`;
exports.FlowDownstreamDashboardsFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamDashboardsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamDashboardsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamDashboardsDocument = (0, client_1.gql) `
    query FlowDownstreamDashboards($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamDatabasesFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamDatabasesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatabasesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: downstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: downstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.FlowDownstreamDatabasesDocument = (0, client_1.gql) `
    query FlowDownstreamDatabases($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.FlowDownstreamDatasourcesFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamDatasourcesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamDatasourcesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamDatasourcesDocument = (0, client_1.gql) `
    query FlowDownstreamDatasources($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamFlowsFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamFlowsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamFlowsDocument = (0, client_1.gql) `
    query FlowDownstreamFlows($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamLensesFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamLensesFilteredByFlowOutputField($vizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  flows(filter: {vizportalUrlId: $vizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...LensesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamLensesDocument = (0, client_1.gql) `
    query FlowDownstreamLenses($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  flows(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamMetricsFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamMetricsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...MetricsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamMetricsDocument = (0, client_1.gql) `
    query FlowDownstreamMetrics($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamOwnerIdsFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamOwnerIdsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFields(filter: {id: $selectedFlowOutputFieldId}) {
      downstreamOwnersConnection(first: $first, offset: $offset) {
        totalCount
        nodes {
          ...OwnerId
        }
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.FlowDownstreamOwnerIdsDocument = (0, client_1.gql) `
    query FlowDownstreamOwnerIds($flowVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.FlowDownstreamOwnersFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamOwnersFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...OwnersDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamOwnersDocument = (0, client_1.gql) `
    query FlowDownstreamOwners($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamSheetsFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamSheetsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamSheetsDocument = (0, client_1.gql) `
    query FlowDownstreamSheets($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamTablesFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamTablesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: downstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: downstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.FlowDownstreamTablesDocument = (0, client_1.gql) `
    query FlowDownstreamTables($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.FlowDownstreamWorkbooksFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowDownstreamWorkbooksFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.FlowDownstreamWorkbooksDocument = (0, client_1.gql) `
    query FlowDownstreamWorkbooks($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.FlowFieldDetailsDocument = (0, client_1.gql) `
    query FlowFieldDetails($flowOutputStepId: ID!, $flowFieldId: ID!) {
  flowOutputSteps(filter: {id: $flowOutputStepId}) {
    outputFields(filter: {id: $flowFieldId}) {
      name
      __typename
      ... on FlowColumnOutputField {
        id
        column {
          id
          name
          table {
            id
            name
          }
        }
      }
      ... on FlowFieldOutputField {
        ...FlowFieldDetailsFlowFieldOutputField
      }
    }
  }
}
    ${exports.FlowFieldDetailsFlowFieldOutputFieldFragmentDoc}`;
exports.FlowFieldsByIdDocument = (0, client_1.gql) `
    query FlowFieldsById($flowVizportalUrlId: String!, $selectedOutputStepId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowOutputFieldSortOrder!, $customSensitivityLabelsEnabled: Boolean!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    vizportalUrlId
    outputSteps(filter: {id: $selectedOutputStepId}) {
      outputFieldsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowFieldsByIdNodes
        }
      }
    }
  }
}
    ${exports.FlowFieldsByIdNodesFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.UpstreamColumnLabelsFragmentDoc}
${exports.FlowFieldsByIdFlowFieldOutputFieldFragmentDoc}
${exports.FieldLineageUpstreamLabelsFragmentDoc}
${exports.FieldIconFragmentDoc}
${exports.NonDatasourceFieldIconFragmentDoc}`;
exports.FlowLineageCountsFilteredByFieldDocument = (0, client_1.gql) `
    query FlowLineageCountsFilteredByField($flowVizportalUrlId: String!, $outputStepId: ID!, $selectedFieldId: ID!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    ...FlowLineageCounts
    outputSteps(filter: {id: $outputStepId}) {
      filteredFieldsConnection: outputFieldsConnection(filter: {id: $selectedFieldId}) {
        nodes {
          name
          upstreamDatabasesConnection {
            totalCount
          }
          upstreamTablesConnection {
            totalCount
          }
          upstreamVirtualConnectionsConnection {
            totalCount
          }
          upstreamVirtualConnectionTablesConnection {
            totalCount
          }
          upstreamFlowsConnection {
            totalCount
          }
          upstreamDatasourcesConnection {
            totalCount
          }
          downstreamDatabasesConnection {
            totalCount
          }
          downstreamTablesConnection {
            totalCount
          }
          downstreamFlowsConnection {
            totalCount
          }
          downstreamDatasourcesConnection {
            totalCount
          }
          downstreamLensesConnection {
            totalCount
          }
          downstreamWorkbooksConnection {
            totalCount
          }
          downstreamDashboardsConnection {
            totalCount
          }
          downstreamSheetsConnection {
            totalCount
          }
          downstreamMetricsConnection {
            totalCount
          }
          downstreamOwnersConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.FlowLineageCountsFragmentDoc}`;
exports.FlowLineageCountsDocument = (0, client_1.gql) `
    query FlowLineageCounts($flowVizportalUrlId: String!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    ...FlowLineageCounts
  }
}
    ${exports.FlowLineageCountsFragmentDoc}`;
exports.FlowDocument = (0, client_1.gql) `
    query Flow($flowVizportalUrlId: String!) {
  flows(
    filter: {vizportalUrlId: $flowVizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
    outputSteps(orderBy: {field: NAME, direction: ASC}) {
      ...FlowOutputSteps
    }
    downstreamDatasourcesConnection {
      ...FlowDownstreamDatasources
    }
    downstreamDatabasesConnection {
      ...FlowDownstreamDatabases
    }
  }
}
    ${exports.FlowOutputStepsFragmentDoc}
${exports.FlowDownstreamDatasourcesFragmentDoc}
${exports.FlowDownstreamDatabasesFragmentDoc}`;
exports.FlowUpstreamDatabasesFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowUpstreamDatabasesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatabasesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.FlowUpstreamDatabasesDocument = (0, client_1.gql) `
    query FlowUpstreamDatabases($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.FlowUpstreamDatasourcesFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowUpstreamDatasourcesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.FlowUpstreamDatasourcesDocument = (0, client_1.gql) `
    query FlowUpstreamDatasources($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.FlowUpstreamFlowsFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowUpstreamFlowsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.FlowUpstreamFlowsDocument = (0, client_1.gql) `
    query FlowUpstreamFlows($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.FlowUpstreamTablesFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowUpstreamTablesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.FlowUpstreamTablesDocument = (0, client_1.gql) `
    query FlowUpstreamTables($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowUpstreamVirtualConnectionTablesFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamVirtualConnectionTablesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...VirtualConnectionTablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.FlowUpstreamVirtualConnectionTablesDocument = (0, client_1.gql) `
    query FlowUpstreamVirtualConnectionTables($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.FlowUpstreamVirtualConnectionsFilteredByFlowOutputFieldDocument = (0, client_1.gql) `
    query FlowUpstreamVirtualConnectionsFilteredByFlowOutputField($flowVizportalUrlId: String!, $selectedFlowOutputFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    outputFieldsConnection(filter: {id: $selectedFlowOutputFieldId}) {
      nodes {
        upstreamVirtualConnectionsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...VirtualConnectionsDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.FlowUpstreamVirtualConnectionsDocument = (0, client_1.gql) `
    query FlowUpstreamVirtualConnections($flowVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  flows(filter: {vizportalUrlId: $flowVizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseLineageLabelsDocument = (0, client_1.gql) `
    query DatabaseLineageLabels($luid: String) {
  items: databases(filter: {luid: $luid}) {
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.DatabaseTableLineageLabelsDocument = (0, client_1.gql) `
    query DatabaseTableLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: databaseTables(filter: {luid: $luid}) {
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
    columns {
      id
      name
      luid
      table {
        id
        ... on VirtualConnectionTable {
          vizportalUrlId
        }
      }
      ...UpstreamColumnLabels
      labels(filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}) {
        ...Label
      }
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.UpstreamColumnLabelsFragmentDoc}`;
exports.VirtualConnectionLineageLabelsDocument = (0, client_1.gql) `
    query VirtualConnectionLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: virtualConnections(filter: {luid: $luid}) {
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
    tables @include(if: $customSensitivityLabelsEnabled) {
      columns {
        ...InheritedLabelsColumn
      }
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.InheritedLabelsColumnFragmentDoc}
${exports.UpstreamColumnLabelsFragmentDoc}`;
exports.VirtualConnectionTablesLineageLabelsDocument = (0, client_1.gql) `
    query VirtualConnectionTablesLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: virtualConnectionTables(filter: {luid: $luid}) {
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
    columns @include(if: $customSensitivityLabelsEnabled) {
      ...InheritedLabelsColumn
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.InheritedLabelsColumnFragmentDoc}
${exports.UpstreamColumnLabelsFragmentDoc}`;
exports.ColumnLineageLabelsDocument = (0, client_1.gql) `
    query ColumnLineageLabels($id: ID, $customSensitivityLabelsEnabled: Boolean!) {
  items: columns(filter: {id: $id}) {
    id
    ...UpstreamColumnLabels
  }
}
    ${exports.UpstreamColumnLabelsFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.FlowLineageLabelsDocument = (0, client_1.gql) `
    query FlowLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: flows(filter: {luid: $luid}) {
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
    outputFields @include(if: $customSensitivityLabelsEnabled) {
      ...InheritedLabelsFlowOutputField
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.InheritedLabelsFlowOutputFieldFragmentDoc}`;
exports.PublishedDatasourceLineageLabelsDocument = (0, client_1.gql) `
    query PublishedDatasourceLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: publishedDatasources(filter: {luid: $luid}) {
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
    fields @include(if: $customSensitivityLabelsEnabled) {
      ...InheritedLabelsField
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.InheritedLabelsFieldFragmentDoc}`;
exports.EmbeddedDatasourceLineageLabelsDocument = (0, client_1.gql) `
    query EmbeddedDatasourceLineageLabels($id: ID) {
  items: embeddedDatasources(filter: {id: $id}) {
    id
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.ViewLineageLabelsDocument = (0, client_1.gql) `
    query ViewLineageLabels($id: ID) {
  items: views(filter: {id: $id}) {
    id
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.WorkbookLineageLabelsDocument = (0, client_1.gql) `
    query WorkbookLineageLabels($luid: String, $customSensitivityLabelsEnabled: Boolean!) {
  items: workbooks(filter: {luid: $luid}) {
    id
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
    embeddedDatasources @include(if: $customSensitivityLabelsEnabled) {
      fields {
        ...InheritedLabelsField
      }
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.InheritedLabelsFieldFragmentDoc}`;
exports.FieldLineageLabelsDocument = (0, client_1.gql) `
    query FieldLineageLabels($id: ID) {
  items: fields(filter: {id: $id}) {
    id
    ...FieldLabels
  }
}
    ${exports.FieldLabelsFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.FlowColumnFieldLineageLabelsDocument = (0, client_1.gql) `
    query FlowColumnFieldLineageLabels($id: ID!, $customSensitivityLabelsEnabled: Boolean!) {
  items: flowColumnOutputFields(filter: {id: $id}) {
    id
    column {
      ...UpstreamColumnLabels
      labels(filter: {isActive: true}) {
        ...Label
      }
    }
  }
}
    ${exports.UpstreamColumnLabelsFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.FlowFieldLineageLabelsDocument = (0, client_1.gql) `
    query FlowFieldLineageLabels($id: ID!) {
  items: flowFieldOutputFields(filter: {id: $id}) {
    id
    field {
      ...FieldLabels
    }
  }
}
    ${exports.FieldLabelsFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.MetricLineageLabelsDocument = (0, client_1.gql) `
    query MetricLineageLabels($luid: String) {
  items: metrics(filter: {luid: $luid}) {
    id
    upstreamLabels(
      filter: {isActive: true, categoryWithin: ["WARNING", "SENSITIVITY"]}
    ) {
      ...Label
    }
  }
}
    ${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.GetUserDocument = (0, client_1.gql) `
    query GetUser($luids: [String]) {
  items: tableauUsers(filter: {luidWithin: $luids}) {
    ...TableauUser
    luid
  }
}
    ${exports.TableauUserFragmentDoc}`;
exports.LabelValueDeleteCountsDocument = (0, client_1.gql) `
    query LabelValueDeleteCounts($labelValueName: String!) {
  dataQualityWarningsConnection(filter: {value: $labelValueName}) {
    totalCount
  }
  genericLabelsConnection(filter: {value: $labelValueName}) {
    totalCount
  }
}
    `;
exports.LensDownstreamDashboardsDocument = (0, client_1.gql) `
    query LensDownstreamDashboards($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.LensDownstreamMetricsDocument = (0, client_1.gql) `
    query LensDownstreamMetrics($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.LensDownstreamOwnerIdsDocument = (0, client_1.gql) `
    query LensDownstreamOwnerIds($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.LensDownstreamOwnersDocument = (0, client_1.gql) `
    query LensDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.LensDownstreamWorkbooksDocument = (0, client_1.gql) `
    query LensDownstreamWorkbooks($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.LensFieldDetailsDocument = (0, client_1.gql) `
    query LensFieldDetails($lensFieldId: ID!) {
  lensFields(filter: {id: $lensFieldId}) {
    name
    description
    datasourceField {
      datasource {
        ... on PublishedDatasource {
          vizportalUrlId
        }
      }
      ...FieldDetails
    }
  }
}
    ${exports.FieldDetailsFragmentDoc}
${exports.FieldDetailsDatasourceFieldFragmentDoc}
${exports.NonDatasourceFieldDetailsFragmentDoc}
${exports.NonDatasourceFieldDetails_ColumnFragmentDoc}
${exports.NonDatasourceFieldDetails_UpstreamColumnFragmentDoc}`;
exports.LensFieldsByIdDocument = (0, client_1.gql) `
    query LensFieldsById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensFieldSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    fieldsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensFieldsByIdFieldsConnectionNodes
      }
    }
  }
}
    ${exports.LensFieldsByIdFieldsConnectionNodesFragmentDoc}
${exports.FieldIconFragmentDoc}
${exports.NonDatasourceFieldIconFragmentDoc}`;
exports.LensLineageCountsDocument = (0, client_1.gql) `
    query LensLineageCounts($vizportalUrlId: String!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...LensLineageCounts
  }
}
    ${exports.LensLineageCountsFragmentDoc}`;
exports.LensDocument = (0, client_1.gql) `
    query Lens($vizportalUrlId: String!) {
  lenses(
    filter: {vizportalUrlId: $vizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
  }
}
    `;
exports.LensUpstreamDatabasesDocument = (0, client_1.gql) `
    query LensUpstreamDatabases($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.LensUpstreamDatasourcesDocument = (0, client_1.gql) `
    query LensUpstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.LensUpstreamFlowsDocument = (0, client_1.gql) `
    query LensUpstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.LensUpstreamTablesDocument = (0, client_1.gql) `
    query LensUpstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.LensUpstreamVirtualConnectionTablesDocument = (0, client_1.gql) `
    query LensUpstreamVirtualConnectionTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.LensUpstreamVirtualConnectionsDocument = (0, client_1.gql) `
    query LensUpstreamVirtualConnections($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  lenses(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      ...LensUpstreamVirtualConnectionsNodes
    }
    maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.LensUpstreamVirtualConnectionsNodesFragmentDoc}
${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.SiteDocument = (0, client_1.gql) `
    query Site {
  tableauSites {
    id
    luid
  }
}
    `;
exports.TableColumnsByIdDocument = (0, client_1.gql) `
    query TableColumnsById($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: ColumnSortOrder!, $customSensitivityLabelsEnabled: Boolean!) {
  tablesConnection(filter: {id: $tableId}) {
    nodes {
      id
      name
      ... on DatabaseTable {
        schema
        vizportalId
      }
      columnsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TableColumnsByIdColumns
        }
      }
    }
  }
}
    ${exports.TableColumnsByIdColumnsFragmentDoc}
${exports.TagsFragmentDoc}
${exports.ColumnsByTableIdFragmentDoc}
${exports.ColumnLabelsFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.UpstreamColumnLabelsFragmentDoc}`;
exports.TableDownstreamDashboardsFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamDashboardsFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamDashboardsDocument = (0, client_1.gql) `
    query TableDownstreamDashboards($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamDatabasesFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamDatabasesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.TableDownstreamDatabasesDocument = (0, client_1.gql) `
    query TableDownstreamDatabases($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.TableDownstreamFlowsFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamFlowsFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamFlowsDocument = (0, client_1.gql) `
    query TableDownstreamFlows($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamLensesFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamLensesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...LensesDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamLensesDocument = (0, client_1.gql) `
    query TableDownstreamLenses($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamMetricsFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamMetricsFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamMetricsDocument = (0, client_1.gql) `
    query TableDownstreamMetrics($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamOwnerIdsFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamOwnerIdsFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!) {
  columns(filter: {id: $columnId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.TableDownstreamOwnerIdsDocument = (0, client_1.gql) `
    query TableDownstreamOwnerIds($tableId: ID!, $first: Int!, $offset: Int!) {
  tables(filter: {id: $tableId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.TableDownstreamOwnersFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamOwnersFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamOwnersDocument = (0, client_1.gql) `
    query TableDownstreamOwners($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamPublishedDatasourcesFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamPublishedDatasourcesFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamPublishedDatasourcesDocument = (0, client_1.gql) `
    query TableDownstreamPublishedDatasources($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamSheetsFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamSheetsFilteredByColumn($columnId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  columns(filter: {id: $columnId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamSheetsDocument = (0, client_1.gql) `
    query TableDownstreamSheets($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamTablesFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamTablesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.TableDownstreamTablesDocument = (0, client_1.gql) `
    query TableDownstreamTables($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.TableDownstreamVirtualConnectionTablesFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamVirtualConnectionTablesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamVirtualConnectionTablesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...VirtualConnectionTablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.TableDownstreamVirtualConnectionTablesDocument = (0, client_1.gql) `
    query TableDownstreamVirtualConnectionTables($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.TableDownstreamVirtualConnectionsFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamVirtualConnectionsFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamVirtualConnectionsConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...VirtualConnectionsDisplayGridRowData
        }
      }
      maxDownstreamDatasources: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: downstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.TableDownstreamVirtualConnectionsDocument = (0, client_1.gql) `
    query TableDownstreamVirtualConnections($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: downstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.TableDownstreamWorkbooksFilteredByColumnDocument = (0, client_1.gql) `
    query TableDownstreamWorkbooksFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...WorkbooksDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.TableDownstreamWorkbooksDocument = (0, client_1.gql) `
    query TableDownstreamWorkbooks($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  tables(filter: {id: $tableId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.TableLineageCountsFilteredByColumnDocument = (0, client_1.gql) `
    query TableLineageCountsFilteredByColumn($tableId: ID!, $columnId: ID!) {
  tables(filter: {id: $tableId}) {
    ...TableLineageCounts
    filteredColumnsConnection: columnsConnection(filter: {id: $columnId}) {
      nodes {
        name
        id
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamVirtualConnectionsConnection {
          totalCount
        }
        downstreamVirtualConnectionTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TableLineageCountsFragmentDoc}`;
exports.TableLineageCountsDocument = (0, client_1.gql) `
    query TableLineageCounts($tableId: ID!) {
  tables(filter: {id: $tableId}) {
    ...TableLineageCounts
  }
}
    ${exports.TableLineageCountsFragmentDoc}`;
exports.TableDocument = (0, client_1.gql) `
    query Table($tableId: ID!) {
  tables(filter: {id: $tableId}, permissionMode: FILTER_RESULTS) {
    ...TableQuery
  }
}
    ${exports.TableQueryFragmentDoc}
${exports.TableFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DataQualityWarningFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.TableUpstreamDatabasesFilteredByColumnDocument = (0, client_1.gql) `
    query TableUpstreamDatabasesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.TableUpstreamDatabasesDocument = (0, client_1.gql) `
    query TableUpstreamDatabases($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.TableUpstreamDatasourcesFilteredByColumnDocument = (0, client_1.gql) `
    query TableUpstreamDatasourcesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.TableUpstreamDatasourcesDocument = (0, client_1.gql) `
    query TableUpstreamDatasources($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.TableUpstreamFlowsFilteredByColumnDocument = (0, client_1.gql) `
    query TableUpstreamFlowsFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.TableUpstreamFlowsDocument = (0, client_1.gql) `
    query TableUpstreamFlows($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.TableUpstreamTablesFilteredByColumnDocument = (0, client_1.gql) `
    query TableUpstreamTablesFilteredByColumn($tableId: ID!, $columnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    columns(filter: {id: $columnId}) {
      upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.TableUpstreamTablesDocument = (0, client_1.gql) `
    query TableUpstreamTables($tableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  tables(filter: {id: $tableId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.TablesByTagDocument = (0, client_1.gql) `
    query TablesByTag($tagName: String!, $first: Int!, $offset: Int!, $textSearch: String, $orderBy: DatabaseTableSortOrder!, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  tags(filter: {name: $tagName}) {
    databaseTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      permissionMode: FILTER_RESULTS
    ) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
        ...Tags
      }
    }
    maxDownstreamDatasources: databaseTablesConnection(
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: databaseTablesConnection(
      filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}
${exports.TagsFragmentDoc}`;
exports.TablesDocument = (0, client_1.gql) `
    query Tables($first: Int!, $offset: Int!, $textSearch: String, $orderBy: DatabaseTableSortOrder!, $hasActiveWarning: Boolean, $isCertified: Boolean) {
  databaseTablesConnection(
    first: $first
    offset: $offset
    orderBy: $orderBy
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    permissionMode: FILTER_RESULTS
  ) {
    totalCount
    nodes {
      ...TablesDisplayGridRowData
      ...Tags
    }
  }
  maxDownstreamDatasources: databaseTablesConnection(
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
    first: 1
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamDatasourcesConnection {
        totalCount
      }
    }
  }
  maxDownstreamWorkbooks: databaseTablesConnection(
    filter: {hasActiveWarning: $hasActiveWarning, isCertified: $isCertified, text: $textSearch}
    orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
    first: 1
    permissionMode: FILTER_RESULTS
  ) {
    nodes {
      downstreamWorkbooksConnection {
        totalCount
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}
${exports.TagsFragmentDoc}`;
exports.TagsQueryWithFiltersDocument = (0, client_1.gql) `
    query TagsQueryWithFilters($first: Int!, $connectionTypeFilter: String, $hasActiveWarningFilter: Boolean, $isCertifiedFilter: Boolean, $isEmbeddedFilter: Boolean, $name: String, $offset: Int!, $textSearch: String) {
  tagsConnection(
    filter: {text: $name}
    first: $first
    offset: $offset
    orderBy: {field: NAME, direction: ASC}
  ) {
    ...TagsQueryWithFiltersTagsConnection
  }
}
    ${exports.TagsQueryWithFiltersTagsConnectionFragmentDoc}
${exports.TagsQueryWithFiltersTagsConnectionNodesFragmentDoc}`;
exports.UpstreamDatabasesFilteredByFieldDocument = (0, client_1.gql) `
    query UpstreamDatabasesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatabasesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamDatabasesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.UpstreamDatasourcesFilteredByFieldDocument = (0, client_1.gql) `
    query UpstreamDatasourcesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...DatasourcesDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.UpstreamFlowsFilteredByFieldDocument = (0, client_1.gql) `
    query UpstreamFlowsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...FlowsDisplayGridRowData
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.UpstreamTablesFilteredByFieldDocument = (0, client_1.gql) `
    query UpstreamTablesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.UpstreamVirtualConnectionTablesFilteredByFieldDocument = (0, client_1.gql) `
    query UpstreamVirtualConnectionTablesFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamVirtualConnectionTablesConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...TablesDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.UpstreamVirtualConnectionsFilteredByFieldDocument = (0, client_1.gql) `
    query UpstreamVirtualConnectionsFilteredByField($selectedFieldId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  fieldsConnection(filter: {id: $selectedFieldId}) {
    nodes {
      upstreamVirtualConnectionsConnection(
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...VirtualConnectionsDisplayGridRowData
        }
      }
      maxDownstreamDatasources: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamDatasourcesConnection {
            totalCount
          }
        }
      }
      maxDownstreamWorkbooks: upstreamTablesConnection(
        orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
        first: 1
      ) {
        nodes {
          downstreamWorkbooksConnection {
            totalCount
          }
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.ViewDetailsByPathDocument = (0, client_1.gql) `
    query ViewDetailsByPath($viewPath: String!) {
  views(filter: {path: $viewPath}, permissionMode: FILTER_RESULTS) {
    ...ViewDetailsByPath
  }
}
    ${exports.ViewDetailsByPathFragmentDoc}
${exports.ViewDetailsByPathDashboardFragmentDoc}
${exports.SheetFieldInstanceFragmentDoc}
${exports.SheetFieldInstanceDatasourceFragmentDoc}
${exports.SheetFieldInstancePublishedDatasourceFragmentDoc}
${exports.SheetFieldInstanceDatasourceFieldFragmentDoc}
${exports.NonDatasourceFieldDetailsFragmentDoc}
${exports.NonDatasourceFieldDetails_ColumnFragmentDoc}
${exports.NonDatasourceFieldDetails_UpstreamColumnFragmentDoc}
${exports.DatasourceFieldDetails_RemoteColumnFragmentDoc}
${exports.SheetFieldInstanceUpstreamDatabasesConnectionFragmentDoc}
${exports.ViewDetailsByPathSheetFragmentDoc}`;
exports.VirtualConnectionDownstreamDashboardsFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamDashboardsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamDashboardsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamDashboardsDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamDashboards($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamDatasourcesFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamDatasourcesFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamDatasourcesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamDatasourcesDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamFlowsFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamFlowsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamFlowsDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamLensesFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamLensesFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...LensesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamLensesDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamLenses($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamMetricsFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamMetricsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...MetricsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamMetricsDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamMetrics($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamOwnerIdsFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamOwnerIdsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tables(filter: {id: $selectedColumnId}) {
      downstreamOwnersConnection(first: $first, offset: $offset) {
        totalCount
        nodes {
          ...OwnerId
        }
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.VirtualConnectionDownstreamOwnerIdsDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamOwnerIds($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.VirtualConnectionDownstreamOwnersFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamOwnersFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...OwnersDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamOwnersDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamSheetsFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamSheetsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamSheetsDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamSheets($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamWorkbooksFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamWorkbooksFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionDownstreamWorkbooksDocument = (0, client_1.gql) `
    query VirtualConnectionDownstreamWorkbooks($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionLineageCountsFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionLineageCountsFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionLineageCounts
    filteredTablesConnection: tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamFlowsConnection {
          totalCount
        }
        upstreamDatasourcesConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionLineageCountsFragmentDoc}`;
exports.VirtualConnectionLineageCountsDocument = (0, client_1.gql) `
    query VirtualConnectionLineageCounts($vizportalUrlId: String!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionLineageCounts
  }
}
    ${exports.VirtualConnectionLineageCountsFragmentDoc}`;
exports.VirtualConnectionDocument = (0, client_1.gql) `
    query VirtualConnection($vizportalUrlId: String!) {
  virtualConnections(
    filter: {vizportalUrlId: $vizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
    tables(orderBy: {field: NAME, direction: ASC}) {
      ...VirtualConnectionTables
    }
  }
}
    ${exports.VirtualConnectionTablesFragmentDoc}`;
exports.VirtualConnectionTableColumnsByIdDocument = (0, client_1.gql) `
    query VirtualConnectionTableColumnsById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: ColumnSortOrder!, $customSensitivityLabelsEnabled: Boolean!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    columnsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...ColumnsByTableId
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.ColumnsByTableIdFragmentDoc}
${exports.ColumnLabelsFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.UpstreamColumnLabelsFragmentDoc}`;
exports.VirtualConnectionTableDownstreamDashboardsFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamDashboardsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamDashboardsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DashboardsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamDashboardsDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamDashboards($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDashboardsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamDatasourcesFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamDatasourcesFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamDatasourcesConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...DatasourcesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamDatasourcesDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamDatasources($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamDatasourcesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamFlowsFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamFlowsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...FlowsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamFlowsDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamFlows($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamLensesFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamLensesFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...LensesDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamLensesDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamLenses($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamMetricsFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamMetricsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...MetricsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamMetricsDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamMetrics($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamOwnerIdsFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamOwnerIdsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columns(filter: {id: $selectedColumnId}) {
      downstreamOwnersConnection(first: $first, offset: $offset) {
        totalCount
        nodes {
          ...OwnerId
        }
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.VirtualConnectionTableDownstreamOwnerIdsDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamOwnerIds($vizportalUrlId: String!, $first: Int!, $offset: Int!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.VirtualConnectionTableDownstreamOwnersFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamOwnersFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...OwnersDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamOwnersDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamSheetsFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamSheetsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamSheetsDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamSheets($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamWorkbooksFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamWorkbooksFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...WorkbooksDisplayGridRowData
          }
        }
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableDownstreamWorkbooksDocument = (0, client_1.gql) `
    query VirtualConnectionTableDownstreamWorkbooks($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: WorkbookSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamWorkbooksConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...WorkbooksDisplayGridRowData
      }
    }
  }
}
    ${exports.WorkbooksDisplayGridRowDataFragmentDoc}`;
exports.VirtualConnectionTableLineageCountsFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableLineageCountsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionTableLineageCounts
    filteredColumnsConnection: columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        name
        upstreamDatabasesConnection {
          totalCount
        }
        upstreamTablesConnection {
          totalCount
        }
        upstreamVirtualConnectionsConnection {
          totalCount
        }
        downstreamDatabasesConnection {
          totalCount
        }
        downstreamTablesConnection {
          totalCount
        }
        downstreamFlowsConnection {
          totalCount
        }
        downstreamDatasourcesConnection {
          totalCount
        }
        downstreamLensesConnection {
          totalCount
        }
        downstreamWorkbooksConnection {
          totalCount
        }
        downstreamDashboardsConnection {
          totalCount
        }
        downstreamSheetsConnection {
          totalCount
        }
        downstreamMetricsConnection {
          totalCount
        }
        downstreamOwnersConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTableLineageCountsFragmentDoc}`;
exports.VirtualConnectionTableLineageCountsDocument = (0, client_1.gql) `
    query VirtualConnectionTableLineageCounts($vizportalUrlId: String!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    ...VirtualConnectionTableLineageCounts
  }
}
    ${exports.VirtualConnectionTableLineageCountsFragmentDoc}`;
exports.VirtualConnectionTableDocument = (0, client_1.gql) `
    query VirtualConnectionTable($vizportalUrlId: String!) {
  virtualConnectionTables(
    filter: {vizportalUrlId: $vizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
    columns(orderBy: {field: NAME, direction: ASC}) {
      name
      id
    }
  }
}
    `;
exports.VirtualConnectionTableUpstreamDatabasesFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableUpstreamDatabasesFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatabasesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.VirtualConnectionTableUpstreamDatabasesDocument = (0, client_1.gql) `
    query VirtualConnectionTableUpstreamDatabases($vizportalUrlId: String, $first: Int, $offset: Int, $orderBy: DatabaseSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.VirtualConnectionTableUpstreamTablesFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableUpstreamTablesFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.VirtualConnectionTableUpstreamTablesDocument = (0, client_1.gql) `
    query VirtualConnectionTableUpstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumnDocument = (0, client_1.gql) `
    query VirtualConnectionTableUpstreamVirtualConnectionsFilteredByColumn($vizportalUrlId: String!, $selectedColumnId: ID!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    columnsConnection(filter: {id: $selectedColumnId}) {
      nodes {
        upstreamVirtualConnectionsConnection(
          first: $first
          offset: $offset
          orderBy: $orderBy
        ) {
          totalCount
          nodes {
            ...VirtualConnectionsDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.VirtualConnectionTableUpstreamVirtualConnectionsDocument = (0, client_1.gql) `
    query VirtualConnectionTableUpstreamVirtualConnections($vizportalUrlId: String, $first: Int, $offset: Int, $orderBy: VirtualConnectionSortOrder!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamVirtualConnectionsConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.VirtualConnectionTablesByIdDocument = (0, client_1.gql) `
    query VirtualConnectionTablesById($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    id
    name
    vizportalUrlId
    tablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.VirtualConnectionUpstreamDatabasesFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionUpstreamDatabasesFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...DatabasesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamDatabasesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.VirtualConnectionUpstreamDatabasesDocument = (0, client_1.gql) `
    query VirtualConnectionUpstreamDatabases($vizportalUrlId: String, $first: Int, $offset: Int, $orderBy: DatabaseSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.VirtualConnectionUpstreamTablesFilteredByTableDocument = (0, client_1.gql) `
    query VirtualConnectionUpstreamTablesFilteredByTable($vizportalUrlId: String!, $selectedTableId: ID!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    tablesConnection(filter: {id: $selectedTableId}) {
      nodes {
        upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...TablesDisplayGridRowData
          }
        }
        maxDownstreamDatasources: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamDatasourcesConnection {
              totalCount
            }
          }
        }
        maxDownstreamWorkbooks: upstreamTablesConnection(
          orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
          first: 1
        ) {
          nodes {
            downstreamWorkbooksConnection {
              totalCount
            }
          }
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.VirtualConnectionUpstreamTablesDocument = (0, client_1.gql) `
    query VirtualConnectionUpstreamTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  virtualConnections(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.WorkbookDownstreamDashboardsDocument = (0, client_1.gql) `
    query WorkbookDownstreamDashboards($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DashboardSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    dashboardsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DashboardsDisplayGridRowData
      }
    }
  }
}
    ${exports.DashboardsDisplayGridRowDataFragmentDoc}`;
exports.WorkbookDownstreamMetricsDocument = (0, client_1.gql) `
    query WorkbookDownstreamMetrics($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: MetricSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    downstreamMetricsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...MetricsDisplayGridRowData
      }
    }
  }
}
    ${exports.MetricsDisplayGridRowDataFragmentDoc}`;
exports.WorkbookDownstreamOwnerIdsDocument = (0, client_1.gql) `
    query WorkbookDownstreamOwnerIds($WorkbookVizportalUrlId: String!, $first: Int!, $offset: Int!) {
  workbooks(filter: {vizportalUrlId: $WorkbookVizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset) {
      totalCount
      nodes {
        ...OwnerId
      }
    }
  }
}
    ${exports.OwnerIdFragmentDoc}`;
exports.WorkbookDownstreamOwnersDocument = (0, client_1.gql) `
    query WorkbookDownstreamOwners($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  workbooks(filter: {vizportalUrlId: $vizportalUrlId}) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowData
      }
    }
  }
}
    ${exports.OwnersDisplayGridRowDataFragmentDoc}`;
exports.WorkbookDownstreamSheetsDocument = (0, client_1.gql) `
    query WorkbookDownstreamSheets($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: SheetSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    sheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...SheetsDisplayGridRowData
      }
    }
  }
}
    ${exports.SheetsDisplayGridRowDataFragmentDoc}`;
exports.WorkbookFieldsByIdDocument = (0, client_1.gql) `
    query WorkbookFieldsById($workbookVizportalUrlId: String!, $selectedEmbeddedDatasourceId: ID!, $first: Int!, $offset: Int!, $orderBy: FieldSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    vizportalUrlId
    embeddedDatasources(filter: {id: $selectedEmbeddedDatasourceId}) {
      fieldsConnection(
        filter: {isHidden: false}
        first: $first
        offset: $offset
        orderBy: $orderBy
      ) {
        totalCount
        nodes {
          ...WorkbookFieldsByIdFieldsConnection
        }
      }
    }
  }
}
    ${exports.WorkbookFieldsByIdFieldsConnectionFragmentDoc}
${exports.FieldIconFragmentDoc}
${exports.NonDatasourceFieldIconFragmentDoc}
${exports.FieldDescriptionInheritedFragmentDoc}
${exports.FieldLineageUpstreamLabelsFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.WorkbookLineageCountsFilteredByFieldDocument = (0, client_1.gql) `
    query WorkbookLineageCountsFilteredByField($workbookVizportalUrlId: String!, $selectedEmbeddedDatasourceId: ID!, $selectedFieldId: ID!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    embeddedDatasources(filter: {id: $selectedEmbeddedDatasourceId}) {
      filteredFieldsConnection: fieldsConnection(filter: {id: $selectedFieldId}) {
        nodes {
          name
          upstreamDatabasesConnection {
            totalCount
          }
          upstreamTablesConnection {
            totalCount
          }
          upstreamVirtualConnectionsConnection {
            totalCount
          }
          upstreamVirtualConnectionTablesConnection {
            totalCount
          }
          upstreamFlowsConnection {
            totalCount
          }
          upstreamDatasourcesConnection {
            totalCount
          }
          sheetsConnection {
            totalCount
          }
          dashboardsConnection: downstreamDashboardsConnection {
            totalCount
          }
          downstreamMetricsConnection {
            totalCount
          }
          downstreamOwnersConnection {
            totalCount
          }
        }
      }
    }
    ...WorkbookLineageCounts
  }
}
    ${exports.WorkbookLineageCountsFragmentDoc}`;
exports.WorkbookLineageCountsDocument = (0, client_1.gql) `
    query WorkbookLineageCounts($workbookVizportalUrlId: String!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    ...WorkbookLineageCounts
  }
}
    ${exports.WorkbookLineageCountsFragmentDoc}`;
exports.WorkbookDocument = (0, client_1.gql) `
    query Workbook($workbookVizportalUrlId: String!) {
  workbooks(
    filter: {vizportalUrlId: $workbookVizportalUrlId}
    permissionMode: FILTER_RESULTS
  ) {
    name
    luid
    embeddedDatasources(orderBy: {field: NAME, direction: ASC}) {
      ...WorkbookEmbeddedDatasource
    }
  }
}
    ${exports.WorkbookEmbeddedDatasourceFragmentDoc}`;
exports.WorkbookUpstreamDatabasesDocument = (0, client_1.gql) `
    query WorkbookUpstreamDatabases($workbookVizportalUrlId: String, $first: Int!, $offset: Int!, $orderBy: DatabaseSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamDatabasesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatabasesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamDatabasesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.DatabasesDisplayGridRowDataFragmentDoc}
${exports.TagsFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.DatabaseIconFragmentDoc}
${exports.DatabaseServerOrPathFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
exports.WorkbookUpstreamDatasourcesDocument = (0, client_1.gql) `
    query WorkbookUpstreamDatasources($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: PublishedDatasourceSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamDatasourcesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...DatasourcesDisplayGridRowData
      }
    }
  }
}
    ${exports.DatasourcesDisplayGridRowDataFragmentDoc}`;
exports.WorkbookUpstreamFlowsDocument = (0, client_1.gql) `
    query WorkbookUpstreamFlows($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: FlowSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamFlowsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...FlowsDisplayGridRowData
      }
    }
  }
}
    ${exports.FlowsDisplayGridRowDataFragmentDoc}`;
exports.WorkbookUpstreamLensesDocument = (0, client_1.gql) `
    query WorkbookUpstreamLenses($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: LensSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamLensesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...LensesDisplayGridRowData
      }
    }
  }
}
    ${exports.LensesDisplayGridRowDataFragmentDoc}`;
exports.WorkbookUpstreamTablesDocument = (0, client_1.gql) `
    query WorkbookUpstreamTables($workbookVizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: DatabaseTableSortOrder!) {
  workbooks(filter: {vizportalUrlId: $workbookVizportalUrlId}) {
    upstreamTablesConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.WorkbookUpstreamVirtualConnectionTablesDocument = (0, client_1.gql) `
    query WorkbookUpstreamVirtualConnectionTables($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionTableSortOrder!) {
  workbooks(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionTablesConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionTablesDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionTablesDisplayGridRowDataFragmentDoc}
${exports.TablesDisplayGridRowDataFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.TableCertificationFragmentDoc}
${exports.LabelFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}
${exports.TableDatabaseNameFragmentDoc}`;
exports.WorkbookUpstreamVirtualConnectionsDocument = (0, client_1.gql) `
    query WorkbookUpstreamVirtualConnections($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: VirtualConnectionSortOrder!) {
  workbooks(filter: {vizportalUrlId: $vizportalUrlId}) {
    upstreamVirtualConnectionsConnection(
      first: $first
      offset: $offset
      orderBy: $orderBy
    ) {
      totalCount
      nodes {
        ...VirtualConnectionsDisplayGridRowData
      }
    }
    maxDownstreamDatasources: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamDatasourcesConnection {
          totalCount
        }
      }
    }
    maxDownstreamWorkbooks: upstreamTablesConnection(
      orderBy: {field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC}
      first: 1
    ) {
      nodes {
        downstreamWorkbooksConnection {
          totalCount
        }
      }
    }
  }
}
    ${exports.VirtualConnectionsDisplayGridRowDataFragmentDoc}
${exports.LabelFragmentDoc}
${exports.TableauUserFragmentDoc}
${exports.LabelAssetFragmentDoc}
${exports.AssetFragmentDoc}`;
//# sourceMappingURL=queries.js.map